// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Plan, PlanService } from "@penji/shared/data-access";

export const environment = {
  back_end_url: 'https://penji.co/',
  firebase: {
    apiKey: 'AIzaSyCjFKj-5lTNn40D9nwN3LE47ZXSdjg6pSw',
    authDomain: 'penji30-455d7.firebaseapp.com',
    databaseURL: 'https://penji30-455d7.firebaseio.com',
    projectId: 'penji30-455d7',
    storageBucket: 'penji30-455d7.appspot.com',
    messagingSenderId: '898355351636',
    appId: '1:898355351636:web:3f7bfabfb4827d0f',
    measurementId: "G-K3KE6D1MV1"
  },
  useEmulators: false,
  production: true,
  google_maps_api_key: 'AIzaSyDt5ePVj7WTAhSsZ7yXBRVmIoerdiI9oOo', // TODO: add your Google Maps API key with Places library enabled
  stripe_publish_key: 'pk_live_PtIii5ZcvJiCqh3a5QdV8X7L',
  // stripe_publish_key: 'pk_test_MQsEBVS6b4czrmTbU6IpnqBc',
  marketplace_front_end_url: 'https://marketplace.penji.co/',
  marketplace_back_end_url: 'https://marketplace-backend.penji.co/',
  api_link: 'https://penji-api-prod-cc47cmrmtq-uc.a.run.app/api',
  api_upload_file_url: 'https://api-upload-file-prod-cc47cmrmtq-uc.a.run.app/api',
  marketplace_checkout_api_url: 'https://marketplace-checkout-api-prod-cc47cmrmtq-uc.a.run.app/api',
  api_heroku: 'https://penjiapi.herokuapp.com:443/api',
  penjico: 'https://penji.co/',
  teamco: 'https://team.penji.co/',
  // Origins of the two customer-facing front-ends. A workspace lives in exactly
  // one of them (`team.use_agency_app`) and users are handed across with a
  // custom token, so these have to be reachable origins — not in-app paths.
  client_app_url: 'https://app.penji.co/',
  agency_app_url: 'https://agency.penji.co/',
  //api link k8s
  api_algolia: 'https://api.penji.co/api-algolia',
  api_checkout: 'https://api.penji.co/api-checkout',
  api_marketplace_checkout: 'https://api.penji.co/api-marketplace-checkout',
  api_project_v2: 'https://api.penji.co/api-project-v2',
  api_team: 'https://api.penji.co/api-team',
  api_postgresql: 'https://api.penji.co/api-postgresql',
  api_stripe: 'https://api.penji.co/api-stripe',
  api_user: 'https://api.penji.co/api-user',
  api_stream: 'https://digitalcut.developer-4e6.workers.dev',
  api_cloudflare: 'https://api.penji.co/api-cloudflare',
  api_gateway: 'https://api.penji.co/api-gateway',
  slack_webhook_bug_report: 'https://hooks.slack.com/services/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',
  slack_client_id: '469990800020.11171924052567',

  // new time offset for countdown and calendar
  TIME_OFFSET_MS: 0 * 24 * 60 * 60 * 1000,
};

// export const list_all_plan: { [key: string]: Plan } = {
//   business_monthly: {
//     plan_id: 'price_1R1lPTI0Oq9o6u7MlOiu8Fy6',
//     plan_order: 1,
//     plan_name: 'Business',
//     plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
//     plan_base: 499,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'business',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Branding & logos',
//       'Illustrations',
//       'Email & Newsletters',
//       'Ad creatives',
//       'Product & packaging designs',
//       'Print designs',
//       'Social media content',
//       'Additional design services'
//     ],
//     plan_management: [
//       '1 project at a time',
//       '1 day delivery',
//       'Self managed'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   business_quarterly: {
//     plan_id: 'price_1R1lQyI0Oq9o6u7M5kmeHmFg',
//     plan_order: 1,
//     plan_name: 'Business',
//     plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
//     plan_base: 499 * 3 * 0.85,
//     plan_save: 499 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'business',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Branding & logos',
//       'Illustrations',
//       'Email & Newsletters',
//       'Ad creatives',
//       'Product & packaging designs',
//       'Print designs',
//       'Social media content',
//       'Additional design services'
//     ],
//     plan_management: [
//       '1 project at a time',
//       '1 day delivery',
//       'Self managed'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   business_yearly: {
//     plan_id: 'price_1R1lRoI0Oq9o6u7M7EXEWrsT',
//     plan_order: 1,
//     plan_name: 'Business',
//     plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
//     plan_base: 499 * 12 * 0.75,
//     plan_save: 499 * 12 * 0.25,
//     plan_percent_off: 25,
//     plan_package: 'business',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Branding & logos',
//       'Illustrations',
//       'Email & Newsletters',
//       'Ad creatives',
//       'Product & packaging designs',
//       'Print designs',
//       'Social media content',
//       'Additional design services'
//     ],
//     plan_management: [
//       '1 project at a time',
//       '1 day delivery',
//       'Self managed'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   marketer_monthly: {
//     plan_id: 'price_1R1lT1I0Oq9o6u7MxakDaXXe',
//     plan_order: 2,
//     plan_name: 'Essentials',
//     plan_subtitle: "For teams looking creative geniuses to power their marketing & advertising campaigns.",
//     plan_base: 995,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'marketer',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Everything in Business',
//       'Canva templates',
//       'Infographics',
//       'Ad creatives',
//       'Hand-drawn illustrations',
//       'Presentations & pitch decks',
//       'Web design (Figma)'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       '1 day delivery',
//       'Fully managed',
//       'Quality control manager'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#8F85FA',
//     plan_text_color: '#22176B'
//   },
//   marketer_quarterly: {
//     plan_id: 'price_1R1lTSI0Oq9o6u7MnxVPENLp',
//     plan_order: 2,
//     plan_name: 'Essentials',
//     plan_subtitle: "For teams looking creative geniuses to power their marketing & advertising campaigns.",
//     plan_base: 995 * 3 * 0.85,
//     plan_save: 995 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'marketer',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Everything in Business',
//       'Canva templates',
//       'Infographics',
//       'Ad creatives',
//       'Hand-drawn illustrations',
//       'Presentations & pitch decks',
//       'Web design (Figma)'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       '1 day delivery',
//       'Fully managed',
//       'Quality control manager'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#8F85FA',
//     plan_text_color: '#22176B'
//   },
//   marketer_yearly: {
//     plan_id: 'price_1R1lU5I0Oq9o6u7MDado0mcd',
//     plan_order: 2,
//     plan_name: 'Essentials',
//     plan_subtitle: "For teams looking creative geniuses to power their marketing & advertising campaigns.",
//     plan_base: 995 * 12 * 0.75,
//     plan_save: 995 * 12 * 0.25,
//     plan_percent_off: 25,
//     plan_package: 'marketer',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Everything in Business',
//       'Canva templates',
//       'Infographics',
//       'Ad creatives',
//       'Hand-drawn illustrations',
//       'Presentations & pitch decks',
//       'Web design (Figma)'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       '1 day delivery',
//       'Fully managed',
//       'Quality control manager'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#8F85FA',
//     plan_text_color: '#22176B'
//   },
//   agency_monthly: {
//     plan_id: 'price_1R1lV5I0Oq9o6u7MJJhZZVDQ',
//     plan_order: 3,
//     plan_name: 'Agency Partner',
//     plan_subtitle: "For Agencies looking to outsource client projects & expand their team.",
//     plan_base: 1497,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'agency',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Everything in Essentials',
//       'Animations',
//       'Motion graphics',
//       'Reels & Short form videos',
//       'Instagram/FB Reels',
//       'Tiktok & Youtube shorts',
//       'Video repurposing'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       'Same day delivery',
//       'Dedicated team',
//       'Quality control manager',
//       'Art director'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   },
//   agency_quarterly: {
//     plan_id: 'price_1R1lVZI0Oq9o6u7MGXSZryUE',
//     plan_order: 3,
//     plan_name: 'Agency Partner',
//     plan_subtitle: "For Agencies looking to outsource client projects & expand their team.",
//     plan_base: 1497 * 3 * 0.85,
//     plan_save: 1497 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'agency',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Everything in Essentials',
//       'Animations',
//       'Motion graphics',
//       'Reels & Short form videos',
//       'Instagram/FB Reels',
//       'Tiktok & Youtube shorts',
//       'Video repurposing'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       'Same day delivery',
//       'Dedicated team',
//       'Quality control manager',
//       'Art director'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   },
//   agency_yearly: {
//     plan_id: 'price_1R1lVvI0Oq9o6u7MJ0LFVptW',
//     plan_order: 3,
//     plan_name: 'Agency Partner',
//     plan_subtitle: "For Agencies looking to outsource client projects & expand their team.",
//     plan_base: 1497 * 12 * 0.75,
//     plan_save: 1497 * 12 * 0.25,
//     plan_percent_off: 25,
//     plan_package: 'agency',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Everything in Essentials',
//       'Animations',
//       'Motion graphics',
//       'Reels & Short form videos',
//       'Instagram/FB Reels',
//       'Tiktok & Youtube shorts',
//       'Video repurposing'
//     ],
//     plan_management: [
//       '2 projects at a time',
//       'Same day delivery',
//       'Dedicated team',
//       'Quality control manager',
//       'Art director'
//     ],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   },
//   access_monthly: {
//     plan_id: 'price_1TBW1UI0Oq9o6u7M4VgGGuMC',
//     plan_order: 1,
//     plan_name: 'Creative Access',
//     plan_subtitle: "For teams that need fast, reliable creative production without long-term commitment.",
//     plan_base: 995,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'access',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Ads, graphics, video edits & design support',
//       'Self managed platform',
//       'Submit requests anytime — no caps, no limits',
//       '2 active projects running simultaneously',
//       'Unlimited revisions',
//       '1-2 days turnaround',
//       'Fast, AI-assisted production'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   access_quarterly: {
//     plan_id: 'price_1TBWBRI0Oq9o6u7MWg4j38gM',
//     plan_order: 1,
//     plan_name: 'Creative Access',
//     plan_subtitle: "For teams that need fast, reliable creative production without long-term commitment.",
//     plan_base: 995 * 3 * 0.85,
//     plan_save: 995 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'access',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Ads, graphics, video edits & design support',
//       'Self managed platform',
//       'Submit requests anytime — no caps, no limits',
//       '2 active projects running simultaneously',
//       'Unlimited revisions',
//       '1-2 days turnaround',
//       'Fast, AI-assisted production'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   access_yearly: {
//     plan_id: 'price_1TBWBtI0Oq9o6u7MdHFC29vY',
//     plan_order: 1,
//     plan_name: 'Creative Access',
//     plan_subtitle: "For teams that need fast, reliable creative production without long-term commitment.",
//     plan_base: 995 * 12 * 0.8,
//     plan_save: 995 * 12 * 0.2,
//     plan_percent_off: 20,
//     plan_package: 'access',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Ads, graphics, video edits & design support',
//       'Self managed platform',
//       'Submit requests anytime — no caps, no limits',
//       '2 active projects running simultaneously',
//       'Unlimited revisions',
//       '1-2 days turnaround',
//       'Fast, AI-assisted production'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#F57FB5',
//     plan_text_color: '#64183D'
//   },
//   team_monthly: {
//     plan_id: 'price_1TAMh2I0Oq9o6u7M9p2Wytas',
//     plan_order: 2,
//     plan_name: 'Creative Team',
//     plan_subtitle: "For teams that need embedded creative execution.",
//     plan_base: 2200,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'team',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5b3df5',
//     plan_text_color: '#ffffff'
//   },
//   team_quarterly: {
//     plan_id: 'price_1TBVePI0Oq9o6u7MBInJuIJI',
//     plan_order: 2,
//     plan_name: 'Creative Team',
//     plan_subtitle: "For teams that need embedded creative execution.",
//     plan_base: 2200 * 3 * 0.85,
//     plan_save: 2200 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'team',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5b3df5',
//     plan_text_color: '#ffffff'
//   },
//   team_yearly: {
//     plan_id: 'price_1TBVRzI0Oq9o6u7M7WePCwFk',
//     plan_order: 2,
//     plan_name: 'Creative Team',
//     plan_subtitle: "For teams that need embedded creative execution.",
//     plan_base: 2200 * 12 * 0.8,
//     plan_save: 2200 * 12 * 0.2,
//     plan_percent_off: 20,
//     plan_package: 'team',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5b3df5',
//     plan_text_color: '#ffffff'
//   },
//   team_pro_monthly: {
//     plan_id: 'price_1TAMpfI0Oq9o6u7MZMdxXBp0',
//     plan_order: 3,
//     plan_name: 'Creative Team Pro',
//     plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
//     plan_base: 4500,
//     plan_save: 0,
//     plan_percent_off: 0,
//     plan_package: 'team_pro',
//     plan_duration: 'monthly',
//     plan_duration_short: 'm',
//     plan_duration_month: 1,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   },
//   team_pro_quarterly: {
//     plan_id: 'price_1TBVhYI0Oq9o6u7Mq3UMu0up',
//     plan_order: 3,
//     plan_name: 'Creative Team Pro',
//     plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
//     plan_base: 4500 * 3 * 0.85,
//     plan_save: 4500 * 3 * 0.15,
//     plan_percent_off: 15,
//     plan_package: 'team_pro',
//     plan_duration: 'quarterly',
//     plan_duration_short: '3m',
//     plan_duration_month: 3,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   },
//   team_pro_yearly: {
//     plan_id: 'price_1TBVUsI0Oq9o6u7MfNozeeqA',
//     plan_order: 3,
//     plan_name: 'Creative Team Pro',
//     plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
//     plan_base: 4500 * 12 * 0.8,
//     plan_save: 4500 * 12 * 0.2,
//     plan_percent_off: 20,
//     plan_package: 'team_pro',
//     plan_duration: 'yearly',
//     plan_duration_short: 'y',
//     plan_duration_month: 12,
//     plan_services: [
//       'Full-service creative with web development',
//       'Art Director-led creative team',
//       'Campaigns & Strategies alignment',
//       '3 concurrent workstreams',
//       'Multi-role creative pod',
//       'Slack integrations',
//       'AI-enhanced workflow'
//     ],
//     plan_management: [],
//     plan_categories: [],
//     plan_bg_color: '#5ED8CF',
//     plan_text_color: '#0A403D'
//   }
// };

export const list_all_plan: { [key: string]: Plan } = {
  // business_monthly: {
  //   plan_id: 'price_1R1lPTI0Oq9o6u7MlOiu8Fy6',
  //   plan_order: 1,
  //   plan_name: 'Business',
  //   plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
  //   plan_base: 499,
  //   plan_save: 0,
  //   plan_percent_off: 0,
  //   plan_package: 'business',
  //   plan_duration: 'monthly',
  //   plan_duration_short: 'm',
  //   plan_duration_month: 1,
  //   plan_services: [
  //     'Branding & logos',
  //     'Illustrations',
  //     'Email & Newsletters',
  //     'Ad creatives',
  //     'Product & packaging designs',
  //     'Print designs',
  //     'Social media content',
  //     'Additional design services'
  //   ],
  //   plan_management: [
  //     '1 project at a time',
  //     '1 day delivery',
  //     'Self managed'
  //   ],
  //   plan_categories: [],
  //   plan_bg_color: '#19A99E',
  //   plan_text_color: '#19A99E',
  //   plan_refund: true,
  // },
  // business_quarterly: {
  //   plan_id: 'price_1R1lQyI0Oq9o6u7M5kmeHmFg',
  //   plan_order: 1,
  //   plan_name: 'Business',
  //   plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
  //   plan_base: 499 * 3 * 0.85,
  //   plan_save: 499 * 3 * 0.15,
  //   plan_percent_off: 15,
  //   plan_package: 'business',
  //   plan_duration: 'quarterly',
  //   plan_duration_short: '3m',
  //   plan_duration_month: 3,
  //   plan_services: [
  //     'Branding & logos',
  //     'Illustrations',
  //     'Email & Newsletters',
  //     'Ad creatives',
  //     'Product & packaging designs',
  //     'Print designs',
  //     'Social media content',
  //     'Additional design services'
  //   ],
  //   plan_management: [
  //     '1 project at a time',
  //     '1 day delivery',
  //     'Self managed'
  //   ],
  //   plan_categories: [],
  //   plan_bg_color: '#19A99E',
  //   plan_text_color: '#19A99E',
  //   plan_refund: false,
  // },
  // business_yearly: {
  //   plan_id: 'price_1R1lRoI0Oq9o6u7M7EXEWrsT',
  //   plan_order: 1,
  //   plan_name: 'Business',
  //   plan_subtitle: "For SMB's & Startups looking for a creative extension of their team.",
  //   plan_base: 499 * 12 * 0.75,
  //   plan_save: 499 * 12 * 0.25,
  //   plan_percent_off: 25,
  //   plan_package: 'business',
  //   plan_duration: 'yearly',
  //   plan_duration_short: 'y',
  //   plan_duration_month: 12,
  //   plan_services: [
  //     'Branding & logos',
  //     'Illustrations',
  //     'Email & Newsletters',
  //     'Ad creatives',
  //     'Product & packaging designs',
  //     'Print designs',
  //     'Social media content',
  //     'Additional design services'
  //   ],
  //   plan_management: [
  //     '1 project at a time',
  //     '1 day delivery',
  //     'Self managed'
  //   ],
  //   plan_categories: [],
  //   plan_bg_color: '#19A99E',
  //   plan_text_color: '#19A99E',
  //   plan_refund: false,
  // },
  marketer_monthly: {
    plan_id: 'price_1TPeluI0Oq9o6u7MnnImX6BN',
    plan_order: 1,
    plan_name: 'Essentials',
    plan_subtitle: "For teams that need fast, reliable creative production without adding headcount.",
    plan_base: 995,
    plan_save: 0,
    plan_percent_off: 0,
    plan_package: 'marketer',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_services: [
      'Branding & Logos',
      'Ad Creatives & Social Media',
      'Email & Newsletters',
      'Print & Packaging',
      'Canva templates',
      'Presentations, illustrations & infographics',
    ],
    plan_management: [
      '2 active workstreams',
      'Best Assigned Creatives',
      'Standard Penji Platform',
      '1 day turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#F04E98',
    plan_text_color: '#19A99E',
    plan_refund: true
  },
  marketer_quarterly: {
    plan_id: 'price_1TPesaI0Oq9o6u7MfVwdsbVU',
    plan_order: 1,
    plan_name: 'Essentials',
    plan_subtitle: "For teams that need fast, reliable creative production without adding headcount.",
    plan_base: 995 * 3 * 0.85,
    plan_save: 995 * 3 * 0.15,
    plan_percent_off: 15,
    plan_package: 'marketer',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_services: [
      'Branding & Logos',
      'Ad Creatives & Social Media',
      'Email & Newsletters',
      'Print & Packaging',
      'Canva templates',
      'Presentations, illustrations & infographics',
    ],
    plan_management: [
      '2 active workstreams',
      'Best Assigned Creatives',
      'Standard Penji Platform',
      '1 day turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#F04E98',
    plan_text_color: '#19A99E',
    plan_refund: false
  },
  marketer_yearly: {
    plan_id: 'price_1TPetDI0Oq9o6u7MvZQea27P',
    plan_order: 1,
    plan_name: 'Essentials',
    plan_subtitle: "For teams that need fast, reliable creative production without adding headcount.",
    plan_base: 995 * 12 * 0.8,
    plan_save: 995 * 12 * 0.2,
    plan_percent_off: 20,
    plan_package: 'marketer',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_services: [
      'Branding & Logos',
      'Ad Creatives & Social Media',
      'Email & Newsletters',
      'Print & Packaging',
      'Canva templates',
      'Presentations, illustrations & infographics',
    ],
    plan_management: [
      '2 active workstreams',
      'Best Assigned Creatives',
      'Standard Penji Platform',
      '1 day turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#F04E98',
    plan_text_color: '#19A99E',
    plan_refund: false
  },
  agency_monthly: {
    plan_id: 'price_1TPewCI0Oq9o6u7MqW4FVSLg',
    plan_order: 2,
    plan_name: 'Agency Partner',
    plan_subtitle: "For agencies looking to scale creative offerings for their clients.",
    plan_base: 1995,
    plan_save: 0,
    plan_percent_off: 0,
    plan_package: 'agency',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_services: [
      'Everything in Essentials',
      'Short-form Videos & Reels',
      'Motion graphics & Animation',
      'Web & landing page design',
      'Everyday design, video, and motion support for your clients',
      'And more...',
    ],
    plan_management: [
      'Art Director',
      '3 active workstreams',
      'Same Assigned Creatives',
      'White Label Agency Platform',
      'Priority turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#5B3DF5',
    plan_text_color: '#F04E98',
    plan_refund: true
  },
  agency_quarterly: {
    plan_id: 'price_1TPf0mI0Oq9o6u7MYmQJJR35',
    plan_order: 2,
    plan_name: 'Agency Partner',
    plan_subtitle: "For agencies looking to scale creative offerings for their clients.",
    plan_base: 1995 * 3 * 0.85,
    plan_save: 1995 * 3 * 0.15,
    plan_percent_off: 15,
    plan_package: 'agency',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_services: [
      'Everything in Essentials',
      'Short-form Videos & Reels',
      'Motion graphics & Animation',
      'Web & landing page design',
      'Everyday design, video, and motion support for your clients',
      'And more...',
    ],
    plan_management: [
      'Art Director',
      '3 active workstreams',
      'Same Assigned Creatives',
      'White Label Agency Platform',
      'Priority turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#5B3DF5',
    plan_text_color: '#F04E98',
    plan_refund: false
  },
  agency_yearly: {
    plan_id: 'price_1TPf1HI0Oq9o6u7MLmBmen2s',
    plan_order: 2,
    plan_name: 'Agency Partner',
    plan_subtitle: "For agencies looking to scale creative offerings for their clients.",
    plan_base: 1995 * 12 * 0.8,
    plan_save: 1995 * 12 * 0.2,
    plan_percent_off: 20,
    plan_package: 'agency',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_services: [
      'Everything in Essentials',
      'Short-form Videos & Reels',
      'Motion graphics & Animation',
      'Web & landing page design',
      'Everyday design, video, and motion support for your clients',
      'And more...',
    ],
    plan_management: [
      'Art Director',
      '3 active workstreams',
      'Same Assigned Creatives',
      'White Label Agency Platform',
      'Priority turnaround'
    ],
    plan_categories: [],
    plan_bg_color: '#5B3DF5',
    plan_text_color: '#F04E98',
    plan_refund: false
  },
  team_monthly: {
    plan_id: 'price_1TPf2tI0Oq9o6u7MhPnb1DbV',
    plan_order: 3,
    plan_name: 'Dedicated Team',
    plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
    plan_base: 4500,
    plan_save: 0,
    plan_percent_off: 0,
    plan_package: 'team',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_services: [
      'Everything in Agency Partner',
      'Full AI-Video production',
      'Full front-end development',
      'Senior-creatives only',
      'Web & landing page design & code',
      'And more...'
    ],
    plan_management: [
      'Senior Art Director',
      '4 active workstreams',
      'Creative Pod',
      'Enterprise Platform',
      'Real-time collaboration'
    ],
    plan_categories: [],
    plan_bg_color: '#22176b',
    plan_text_color: '#5B3DF5',
    plan_refund: true
  },
  team_quarterly: {
    plan_id: 'price_1TPf3TI0Oq9o6u7MxUycQlqh',
    plan_order: 3,
    plan_name: 'Dedicated Team',
    plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
    plan_base: 4500 * 3 * 0.85,
    plan_save: 4500 * 3 * 0.15,
    plan_percent_off: 15,
    plan_package: 'team',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_services: [
      'Everything in Agency Partner',
      'Full AI-Video production',
      'Full front-end development',
      'Senior-creatives only',
      'Web & landing page design & code',
      'And more...'
    ],
    plan_management: [
      'Senior Art Director',
      '4 active workstreams',
      'Creative Pod',
      'Enterprise Platform',
      'Real-time collaboration'
    ],
    plan_categories: [],
    plan_bg_color: '#22176b',
    plan_text_color: '#5B3DF5',
    plan_refund: false
  },
  team_yearly: {
    plan_id: 'price_1TPf3sI0Oq9o6u7MrZzdT1qb',
    plan_order: 3,
    plan_name: 'Dedicated Team',
    plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
    plan_base: 4500 * 12 * 0.8,
    plan_save: 4500 * 12 * 0.2,
    plan_percent_off: 20,
    plan_package: 'team',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_services: [
      'Everything in Agency Partner',
      'Full AI-Video production',
      'Full front-end development',
      'Senior-creatives only',
      'Web & landing page design & code',
      'And more...'
    ],
    plan_management: [
      'Senior Art Director',
      '4 active workstreams',
      'Creative Pod',
      'Enterprise Platform',
      'Real-time collaboration'
    ],
    plan_categories: [],
    plan_bg_color: '#22176b',
    plan_text_color: '#5B3DF5',
    plan_refund: false
  }
  // team_pro_monthly: {
  //   plan_id: 'price_1TAMpfI0Oq9o6u7MZMdxXBp0',
  //   plan_order: 5,
  //   plan_name: 'Creative Team Pro',
  //   plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
  //   plan_base: 4500,
  //   plan_save: 0,
  //   plan_percent_off: 0,
  //   plan_package: 'team_pro',
  //   plan_duration: 'monthly',
  //   plan_duration_short: 'm',
  //   plan_duration_month: 1,
  //   plan_services: [
  //     'Full-service creative with web development',
  //     'Art Director-led creative team',
  //     'Campaigns & Strategies alignment',
  //     '3 concurrent workstreams',
  //     'Multi-role creative pod',
  //     'Slack integrations',
  //     'AI-enhanced workflow' 
  //   ],
  //   plan_management: [],
  //   plan_categories: [],
  //   plan_bg_color: '#0A403D',
  //   plan_text_color: '#FFFFFF'
  // },
  // team_pro_quarterly: {
  //   plan_id: 'price_1TBVhYI0Oq9o6u7Mq3UMu0up',
  //   plan_order: 5,
  //   plan_name: 'Creative Team Pro',
  //   plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
  //   plan_base: 4500 * 3 * 0.85,
  //   plan_save: 4500 * 3 * 0.15,
  //   plan_percent_off: 15,
  //   plan_package: 'team_pro',
  //   plan_duration: 'quarterly',
  //   plan_duration_short: '3m',
  //   plan_duration_month: 3,
  //   plan_services: [
  //     'Full-service creative with web development',
  //     'Art Director-led creative team',
  //     'Campaigns & Strategies alignment',
  //     '3 concurrent workstreams',
  //     'Multi-role creative pod',
  //     'Slack integrations',
  //     'AI-enhanced workflow'
  //   ],
  //   plan_management: [],
  //   plan_categories: [],
  //   plan_bg_color: '#0A403D',
  //   plan_text_color: '#FFFFFF'
  // },
  // team_pro_yearly: {
  //   plan_id: 'price_1TBVUsI0Oq9o6u7MfNozeeqA',
  //   plan_order: 5,
  //   plan_name: 'Creative Team Pro',
  //   plan_subtitle: "For organizations scaling campaigns across multiple brands, departments, or regions.",
  //   plan_base: 4500 * 12 * 0.8,
  //   plan_save: 4500 * 12 * 0.2,
  //   plan_percent_off: 20,
  //   plan_package: 'team_pro',
  //   plan_duration: 'yearly',
  //   plan_duration_short: 'y',
  //   plan_duration_month: 12,
  //   plan_services: [
  //     'Full-service creative with web development',
  //     'Art Director-led creative team',
  //     'Campaigns & Strategies alignment',
  //     '3 concurrent workstreams',
  //     'Multi-role creative pod',
  //     'Slack integrations',
  //     'AI-enhanced workflow'
  //   ],
  //   plan_management: [],
  //   plan_categories: [],
  //   plan_bg_color: '#0A403D',
  //   plan_text_color: '#FFFFFF'
  // }
};

// using for client/team
// export const list_all_plan_beta: { [key: string]: any } = {
//   plans: {
//     access: {
//       product_id: "prod_U9pgKe6SaRv5hB",
//       monthly: "price_1TBW1UI0Oq9o6u7M4VgGGuMC",
//       quarterly: "price_1TBWBRI0Oq9o6u7MWg4j38gM",
//       yearly: "price_1TBWBtI0Oq9o6u7MdHFC29vY",
//       plan_order: 1
//     },
//     team: {
//       product_id: "prod_U8dzlERVg9KZjM",
//       monthly: "price_1TAMh2I0Oq9o6u7M9p2Wytas",
//       quarterly: "price_1TBVePI0Oq9o6u7MBInJuIJI",
//       yearly: "price_1TBVRzI0Oq9o6u7M7WePCwFk",
//       plan_order: 2
//     },
//     team_pro: {
//       product_id: "prod_U8e75bFtXTXXmb",
//       monthly: "price_1TAMpfI0Oq9o6u7MZMdxXBp0",
//       quarterly: "price_1TBVhYI0Oq9o6u7Mq3UMu0up",
//       yearly: "price_1TBVUsI0Oq9o6u7MfNozeeqA",
//       plan_order: 3
//     },
//     business: {
//       product_id: "prod_RKAweUwAaTXiqp",
//       monthly: "price_1R1lPTI0Oq9o6u7MlOiu8Fy6",
//       quarterly: "price_1R1lQyI0Oq9o6u7M5kmeHmFg",
//       yearly: "price_1R1lRoI0Oq9o6u7M7EXEWrsT",
//       plan_order: 4
//     },
//     marketing_and_ads: {
//       product_id: "prod_RKpWKALhW26XRQ",
//       monthly: "price_1R1lT1I0Oq9o6u7MxakDaXXe",
//       quarterly: "price_1R1lTSI0Oq9o6u7MnxVPENLp",
//       yearly: "price_1R1lU5I0Oq9o6u7MDado0mcd",
//       plan_order: 5
//     },
//     agency: {
//       product_id: "prod_RKpfjlZThbKA0w",
//       monthly: "price_1R1lV5I0Oq9o6u7MJJhZZVDQ",
//       quarterly: "price_1R1lVZI0Oq9o6u7MGXSZryUE",
//       yearly: "price_1R1lVvI0Oq9o6u7MJ0LFVptW",
//       plan_order: 6
//     },
//     pause_plan_01: {
//       product_id: "prod_SO1jnPDh0JaA89",
//       monthly: "price_1RTFgGI0Oq9o6u7MObwCmUPF",
//       plan_order: 7
//     },
//     pause_plan_02: {
//       product_id: "prod_SSvb4DDiudASZu",
//       monthly: "price_1RXzkgI0Oq9o6u7MOrSc2cWn",
//       plan_order: 8
//     },
//     pause_plan_03: {
//       product_id: "prod_SSvf7S4cFnMZZo",
//       monthly: "price_1RXzoYI0Oq9o6u7M9iCnpHRN",
//       plan_order: 9
//     },
//     pause_plan_05: {
//       product_id: "prod_SdRRTVxpq7PVwo",
//       monthly: "price_1RiAYtI0Oq9o6u7M7nX9giAT",
//       plan_order: 10
//     }
//   },
//   addons: {
//     extra_slot: {
//       product_id: "prod_RFHaDVNU99sq6g",
//       monthly: "price_1QSAEuI0Oq9o6u7MqKHEi056",
//       quarterly: "price_1QWUmqI0Oq9o6u7MrqEfDWnJ",
//       yearly: "price_1QWUnwI0Oq9o6u7MWadgNhsy"
//     },
//     canva: {
//       product_id: "prod_PRDLDBNjsRE0HO",
//       monthly: "price_1OcKuTI0Oq9o6u7MEf7eqfXs",
//       quarterly: "price_1QqrK3I0Oq9o6u7MmWfhUCTE",
//       yearly: "price_1QqrKOI0Oq9o6u7MJesf8XA6"
//     },
//     figma: {
//       product_id: "prod_Q4D2JKBRGGgx1N",
//       monthly: "price_1PE4cnI0Oq9o6u7MEvnazU8n",
//       quarterly: "price_1RdNXLI0Oq9o6u7Mtcpde7bf",
//       yearly: "price_1RdNXtI0Oq9o6u7MeWfjYCQA"
//     },
//     update_category: {
//       product_id: "prod_SL0p8iqYXYitrj",
//       monthly: "price_1RQKnaI0Oq9o6u7MvpX5e7jp",
//     },
//   },
//   products: {
//     boost_project: {
//       product_id: "prod_RKpy1UOX7Yao9l",
//       price: "price_1QSAIZI0Oq9o6u7McepjaftV",
//       params: ["project_id"]
//     },
//     pause_add_slot: {
//       product_id: "prod_SThoKlEmpWK29L",
//       price: "price_1RYkP1I0Oq9o6u7Mi25VTprQ",
//       params: []
//     },
//   }
// };

export const list_all_plan_beta: { [key: string]: any } = {
  plans: {
    // business: {
    //   product_id: "prod_RKAweUwAaTXiqp",
    //   monthly: "price_1R1lPTI0Oq9o6u7MlOiu8Fy6",
    //   quarterly: "price_1R1lQyI0Oq9o6u7M5kmeHmFg",
    //   yearly: "price_1R1lRoI0Oq9o6u7M7EXEWrsT",
    //   plan_order: 1
    // },
    marketing_and_ads: {
      product_id: "prod_UORfATcOf4sEep",
      monthly: "price_1TPeluI0Oq9o6u7MnnImX6BN",
      quarterly: "price_1TPesaI0Oq9o6u7MfVwdsbVU",
      yearly: "price_1TPetDI0Oq9o6u7MvZQea27P",
      plan_order: 2
    },
    agency: {
      product_id: "prod_UORpUhy2dgIr0s",
      monthly: "price_1TPewCI0Oq9o6u7MqW4FVSLg",
      quarterly: "price_1TPf0mI0Oq9o6u7MYmQJJR35",
      yearly: "price_1TPf1HI0Oq9o6u7MLmBmen2s",
      plan_order: 3
    },
    team: {
      product_id: "prod_UORwenfykqdCSz",
      monthly: "price_1TPf2tI0Oq9o6u7MhPnb1DbV",
      quarterly: "price_1TPf3TI0Oq9o6u7MxUycQlqh",
      yearly: "price_1TPf3sI0Oq9o6u7MrZzdT1qb",
      plan_order: 4
    },
    // team_pro: {
    //   product_id: "prod_U8e75bFtXTXXmb",
    //   monthly: "price_1TAMpfI0Oq9o6u7MZMdxXBp0",
    //   quarterly: "price_1TBVhYI0Oq9o6u7Mq3UMu0up",
    //   yearly: "price_1TBVUsI0Oq9o6u7MfNozeeqA",
    //   plan_order: 5
    // },
    pause_plan_01: {
      product_id: "prod_SO1jnPDh0JaA89",
      monthly: "price_1RTFgGI0Oq9o6u7MObwCmUPF",
      plan_order: 5
    },
    pause_plan_02: {
      product_id: "prod_SSvb4DDiudASZu",
      monthly: "price_1RXzkgI0Oq9o6u7MOrSc2cWn",
      plan_order: 6
    },
    pause_plan_03: {
      product_id: "prod_SSvf7S4cFnMZZo",
      monthly: "price_1RXzoYI0Oq9o6u7M9iCnpHRN",
      plan_order: 7
    },
    pause_plan_05: {
      product_id: "prod_SdRRTVxpq7PVwo",
      monthly: "price_1RiAYtI0Oq9o6u7M7nX9giAT",
      plan_order: 8
    }
  },
  addons: {
    extra_slot: {
      product_id: "prod_RFHaDVNU99sq6g",
      monthly: "price_1TochfI0Oq9o6u7MylRFoFDC",
      quarterly: "price_1TocmZI0Oq9o6u7MwEzgmeWt",
      yearly: "price_1TocmHI0Oq9o6u7MqfD1xfIU"
    },
    canva: {
      product_id: "prod_UoHF3IurNAFZ5M",
      monthly: "price_1ToegmI0Oq9o6u7MdbugDB1c",
      quarterly: "price_1ToehFI0Oq9o6u7MmgawXBO0",
      yearly: "price_1ToehcI0Oq9o6u7Mj6mFi93d"
    },
    figma: {
      product_id: "prod_Q4D2JKBRGGgx1N",
      monthly: "price_1PE4cnI0Oq9o6u7MEvnazU8n",
      quarterly: "price_1RdNXLI0Oq9o6u7Mtcpde7bf",
      yearly: "price_1RdNXtI0Oq9o6u7MeWfjYCQA"
    },
    // update_category: {
    //   product_id: "prod_SL0p8iqYXYitrj",
    //   monthly: "price_1RQKnaI0Oq9o6u7MvpX5e7jp",
    // },
    presentations_infographics: {
      product_id: "prod_UogHp4C9yij6qC",
      monthly: "price_1Tp2vHI0Oq9o6u7M0VnyaU8N",
      quarterly: "price_1Tp2w3I0Oq9o6u7MLizrjN84",
      yearly: "price_1Tp2wNI0Oq9o6u7MIjopwtTu"
    },
    landing_page_web_design: {
      product_id: "prod_UohDHZk6HquxpH",
      monthly: "price_1Tp3pNI0Oq9o6u7MX4zgVLIK",
      quarterly: "price_1Tp3pgI0Oq9o6u7MpwcBtUyf",
      yearly: "price_1Tp3pxI0Oq9o6u7M9FRLe5ZX"
    },
    motion_graphics: {
      product_id: "prod_UohHqfyaJjtXvD",
      monthly: "price_1Tp3snI0Oq9o6u7M6VsGyY1w",
      quarterly: "price_1Tp3tqI0Oq9o6u7MCgMmfess",
      yearly: "price_1Tp3u3I0Oq9o6u7MYXmAEFgO"
    },
    short_form_video_editing: {
      product_id: "prod_UohKEtono393L6",
      monthly: "price_1Tp3vfI0Oq9o6u7MqG7Wo0qM",
      quarterly: "price_1Tp3wDI0Oq9o6u7MhnRhi3HI",
      yearly: "price_1Tp3vxI0Oq9o6u7MShaAXATP"
    },
    white_label: {
      product_id: "prod_UoFEceOEhHniky",
      monthly: "price_1TocjqI0Oq9o6u7MsqAD5Ap1",
      quarterly: "price_1Tocl9I0Oq9o6u7Ml8QbaW8h",
      yearly: "price_1ToclWI0Oq9o6u7McKPPicAC"
    },
  },
  products: {
    boost_project: {
      product_id: "prod_RKpy1UOX7Yao9l",
      price: "price_1QSAIZI0Oq9o6u7McepjaftV",
      params: ["project_id"]
    },
    pause_add_slot: {
      product_id: "prod_SThoKlEmpWK29L",
      price: "price_1RYkP1I0Oq9o6u7Mi25VTprQ",
      params: []
    },
  }
};

export const list_price_2026: { [key: string]: PlanService } = {
  // boosting product
  "price_1QSAIZI0Oq9o6u7McepjaftV": {
    price_id: "price_1QSAIZI0Oq9o6u7McepjaftV",
    product_id: "prod_RKpy1UOX7Yao9l",
    payment_type: "product",
    plan_name: "Boosted projects",
    plan_label: "Boosted Projects",
    plan_description: "Add one extra Active workstream for",
    plan_duration: 'one-time',
    plan_key: 'boost_project',
    plan_includes: [
      'One boosted project slot for',
      'Creatives will be assigned immediately',
      'Same fast turnaround',
      'Unlimited revisions',
    ],
  },
  // extra slot monthly
  "price_1TochfI0Oq9o6u7MylRFoFDC": {
    price_id: "price_1TochfI0Oq9o6u7MylRFoFDC",
    product_id: "prod_RFHaDVNU99sq6g",
    payment_type: "addons",
    plan_name: "Extra Active Project Slot",
    plan_label: "Extra Active Project Slot",
    plan_description: "Run one additional project at the same time without waiting for another active project to finish.",
    plan_bg: 'extraslot.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'extra_slot_monthly',
    plan_includes: [
      '+1 concurrent project slot',
      'Start your next queued project immediately',
      'Same fast turnaround & dedicated creatives',
      'Cancel or downgrade anytime',
    ],
    plan_button_text: 'Add Capacity',
  },
  // extra slot quarterly
  "price_1TocmZI0Oq9o6u7MwEzgmeWt": {
    price_id: "price_1TocmZI0Oq9o6u7MwEzgmeWt",
    product_id: "prod_RFHaDVNU99sq6g",
    payment_type: "addons",
    plan_name: "Extra Active Project Slot",
    plan_label: "Extra Active Project Slot",
    plan_description: "Run one additional project at the same time without waiting for another active project to finish.",
    plan_bg: 'extraslot.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'extra_slot_quarterly',
    plan_includes: [
      '+1 concurrent project slot',
      'Start your next queued project immediately',
      'Same fast turnaround & dedicated creatives',
      'Cancel or downgrade anytime',
    ],
    plan_button_text: 'Add Capacity',
  },
  // extra slot yearly
  "price_1TocmHI0Oq9o6u7MqfD1xfIU": {
    price_id: "price_1TocmHI0Oq9o6u7MqfD1xfIU",
    product_id: "prod_RFHaDVNU99sq6g",
    payment_type: "addons",
    plan_name: "Extra Active Project Slot",
    plan_label: "Extra Active Project Slot",
    plan_description: "Run one additional project at the same time without waiting for another active project to finish.",
    plan_bg: 'extraslot.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'extra_slot_yearly',
    plan_includes: [
      '+1 concurrent project slot',
      'Start your next queued project immediately',
      'Same fast turnaround & dedicated creatives',
      'Cancel or downgrade anytime',
    ],
    plan_button_text: 'Add Capacity',
  },
  // add designer monthly
  "add_designer_monthly": {
    price_id: "add_designer_monthly",
    product_id: "add_designer",
    payment_type: "addons",
    plan_name: "Work more with ",
    plan_label: "Preferred Creative Match",
    plan_description: "Add them to your Pod for more frequent assignment.",
    plan_bg: 'add_designer.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'add_designer_monthly',
    plan_includes: [
      'Priority assignment to this designer on all projects',
      'Consistent brand familiarity  over time',
      'This designer learns your style and preferences',
      'Cancel anytime'
    ],
    plan_button_text: 'Assign',
  },
  // add designer quarterly
  "add_designer_quarterly": {
    price_id: "add_designer_quarterly",
    product_id: "add_designer",
    payment_type: "addons",
    plan_name: "Work more with ",
    plan_label: "Preferred Creative Match",
    plan_description: "Add them to your Pod for more frequent assignment.",
    plan_bg: 'add_designer.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'add_designer_quarterly',
    plan_includes: [
      'Priority assignment to this designer on all projects',
      'Consistent brand familiarity  over time',
      'This designer learns your style and preferences',
      'Cancel anytime'
    ],
    plan_button_text: 'Assign',
  },
  // add designer yearly
  "add_designer_yearly": {
    price_id: "add_designer_yearly",
    product_id: "add_designer",
    payment_type: "addons",
    plan_name: "Work more with ",
    plan_label: "Preferred Creative Match",
    plan_description: "Add them to your Pod for more frequent assignment.",
    plan_bg: 'add_designer.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'add_designer_yearly',
    plan_includes: [
      'Priority assignment to this designer on all projects',
      'Consistent brand familiarity  over time',
      'This designer learns your style and preferences',
      'Cancel anytime'
    ],
    plan_button_text: 'Assign',
  },
  // add ad monthly
  "add_ad_monthly": {
    price_id: "add_ad_monthly",
    product_id: "add_ad",
    payment_type: "addons",
    plan_name: "Need creative oversight?",
    plan_label: "Creative Direction Add-On",
    plan_description: "Want someone to turn your ideas into a campaign? Art Director helps manage projects, brand alignment, and finding the best talents for your projects.",
    plan_bg: 'add_ad.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'add_ad_monthly',
    plan_includes: [
      'Art Director reviews every project brief',
      'Campaign strategy & brand alignment',
      'Talent matching for best creative results',
      'Monthly strategy check-in call'
    ],
    plan_button_text: 'Add Senior AD',
  },
  // add ad quarterly
  "add_ad_quarterly": {
    price_id: "add_ad_quarterly",
    product_id: "add_ad",
    payment_type: "addons",
    plan_name: "Need creative oversight?",
    plan_label: "Creative Direction Add-On",
    plan_description: "Want someone to turn your ideas into a campaign? Art Director helps manage projects, brand alignment, and finding the best talents for your projects.",
    plan_bg: 'add_ad.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'add_ad_quarterly',
    plan_includes: [
      'Art Director reviews every project brief',
      'Campaign strategy & brand alignment',
      'Talent matching for best creative results',
      'Monthly strategy check-in call'
    ],
    plan_button_text: 'Add Senior AD',
  },
  // add ad yearly
  "add_ad_yearly": {
    price_id: "add_ad_yearly",
    product_id: "add_ad",
    payment_type: "addons",
    plan_name: "Need creative oversight?",
    plan_label: "Creative Direction Add-On",
    plan_description: "Want someone to turn your ideas into a campaign? Art Director helps manage projects, brand alignment, and finding the best talents for your projects.",
    plan_bg: 'add_ad.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'add_ad_yearly',
    plan_includes: [
      'Art Director reviews every project brief',
      'Campaign strategy & brand alignment',
      'Talent matching for best creative results',
      'Monthly strategy check-in call'
    ],
    plan_button_text: 'Add Senior AD',
  },
  // add canva monthly
  "price_1ToegmI0Oq9o6u7MdbugDB1c": {
    price_id: "price_1ToegmI0Oq9o6u7MdbugDB1c",
    product_id: "prod_UoHF3IurNAFZ5M",
    payment_type: "addons",
    plan_name: "Editable Canva Templates",
    plan_label: "Editable Canva Templates",
    plan_description: "Receive editable Canva templates your team can reuse, resize, and customize them internally.",
    plan_bg: 'add_canva.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'add_canva_monthly',
    plan_includes: [
      'Branded Canva template library',
      'Resize and customize without designers',
      'New templates added monthly',
      'Full source file access'
    ],
  },
  // add canva quarterly
  "price_1ToehFI0Oq9o6u7MmgawXBO0": {
    price_id: "price_1ToehFI0Oq9o6u7MmgawXBO0",
    product_id: "prod_UoHF3IurNAFZ5M",
    payment_type: "addons",
    plan_name: "Editable Canva Templates",
    plan_label: "Editable Canva Templates",
    plan_description: "Receive editable Canva templates your team can reuse, resize, and customize them internally.",
    plan_bg: 'add_canva.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'add_canva_quarterly',
    plan_includes: [
      'Branded Canva template library',
      'Resize and customize without designers',
      'New templates added monthly',
      'Full source file access'
    ],
  },
  // add canva yearly
  "price_1ToehcI0Oq9o6u7Mj6mFi93d": {
    price_id: "price_1ToehcI0Oq9o6u7Mj6mFi93d",
    product_id: "prod_UoHF3IurNAFZ5M",
    payment_type: "addons",
    plan_name: "Editable Canva Templates",
    plan_label: "Editable Canva Templates",
    plan_description: "Receive editable Canva templates your team can reuse, resize, and customize them internally.",
    plan_bg: 'add_canva.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'add_canva_yearly',
    plan_includes: [
      'Branded Canva template library',
      'Resize and customize without designers',
      'New templates added monthly',
      'Full source file access'
    ],
  },
  // Presentations & Infographics monthly
  "price_1Tp2vHI0Oq9o6u7M0VnyaU8N": {
    price_id: "price_1Tp2vHI0Oq9o6u7M0VnyaU8N",
    product_id: "prod_UogHp4C9yij6qC",
    payment_type: "addons",
    plan_name: "Presentations & Infographics",
    plan_label: "Presentations & Infographics",
    plan_description: "Unlock presentation design, pitch decks, sales decks, reports, and infographics.",
    plan_bg: 'add_presentations.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'presentations_infographics_monthly',
    plan_type: 'add_category',
    plan_includes: [
      'Pitch decks and sales presentations',
      'Reports and data visualizations',
      'Branded infographic design',
      'Fast turnaround on deadline projects'
    ],
    included_categories: [
      'd7xnPgIofPtpAx25P5xx', //Presentation & Pitch deck
      'VJD0p8i3FIcDMzcMcv6X', //Infographics
    ]
  },
  // Presentations & Infographics quarterly
  "price_1Tp2w3I0Oq9o6u7MLizrjN84": {
    price_id: "price_1Tp2w3I0Oq9o6u7MLizrjN84",
    product_id: "prod_UogHp4C9yij6qC",
    payment_type: "addons",
    plan_name: "Presentations & Infographics",
    plan_label: "Presentations & Infographics",
    plan_description: "Unlock presentation design, pitch decks, sales decks, reports, and infographics.",
    plan_bg: 'add_presentations.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'presentations_infographics_quarterly',
    plan_includes: [
      'Pitch decks and sales presentations',
      'Reports and data visualizations',
      'Branded infographic design',
      'Fast turnaround on deadline projects'
    ],
    plan_type: 'add_category',
    included_categories: [
      'd7xnPgIofPtpAx25P5xx', //Presentation & Pitch deck
      'VJD0p8i3FIcDMzcMcv6X', //Infographics
    ]
  },
  // Presentations & Infographics yearly
  "price_1Tp2wNI0Oq9o6u7MIjopwtTu": {
    price_id: "price_1Tp2wNI0Oq9o6u7MIjopwtTu",
    product_id: "prod_UogHp4C9yij6qC",
    payment_type: "addons",
    plan_name: "Presentations & Infographics",
    plan_label: "Presentations & Infographics",
    plan_description: "Unlock presentation design, pitch decks, sales decks, reports, and infographics.",
    plan_bg: 'add_presentations.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'presentations_infographics_yearly',
    plan_includes: [
      'Pitch decks and sales presentations',
      'Reports and data visualizations',
      'Branded infographic design',
      'Fast turnaround on deadline projects'
    ],
    plan_type: 'add_category',
    included_categories: [
      'd7xnPgIofPtpAx25P5xx', //Presentation & Pitch deck
      'VJD0p8i3FIcDMzcMcv6X', //Infographics
    ]
  },
  // Landing Page & Web Design monthly
  "price_1Tp3pNI0Oq9o6u7MX4zgVLIK": {
    price_id: "price_1Tp3pNI0Oq9o6u7MX4zgVLIK",
    product_id: "prod_UohDHZk6HquxpH",
    payment_type: "addons",
    plan_name: "Landing Page & Web Design",
    plan_label: "Landing Page & Web Design",
    plan_description: "Design landing pages, website pages, UX/UI layouts, and responsive web mockups.",
    plan_bg: 'add_landing.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'landing_page_web_design_monthly',
    plan_includes: [
      'Landing pages & website sections',
      'UX/UI layouts and wireframes',
      'Responsive web mockups',
      'Figma source files included'
    ],
    plan_type: 'add_category',
    included_categories: [
      'ONwMlLkabJA0Ti1gDCx9', //App design
      'bFaLMhkakrXr4tcPWTr0', //SaaS UI
      'EOJNqVxfop4ejFUFXHF5', //Website design
    ]
  },
  // Landing Page & Web Design quarterly
  "price_1Tp3pgI0Oq9o6u7MpwcBtUyf": {
    price_id: "price_1Tp3pgI0Oq9o6u7MpwcBtUyf",
    product_id: "prod_UohDHZk6HquxpH",
    payment_type: "addons",
    plan_name: "Landing Page & Web Design",
    plan_label: "Landing Page & Web Design",
    plan_description: "Design landing pages, website pages, UX/UI layouts, and responsive web mockups.",
    plan_bg: 'add_landing.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'landing_page_web_design_quarterly',
    plan_includes: [
      'Landing pages & website sections',
      'UX/UI layouts and wireframes',
      'Responsive web mockups',
      'Figma source files included'
    ],
    plan_type: 'add_category',
    included_categories: [
      'ONwMlLkabJA0Ti1gDCx9', //App design
      'bFaLMhkakrXr4tcPWTr0', //SaaS UI
      'EOJNqVxfop4ejFUFXHF5', //Website design
    ]
  },
  // Landing Page & Web Design yearly
  "price_1Tp3pxI0Oq9o6u7M9FRLe5ZX": {
    price_id: "price_1Tp3pxI0Oq9o6u7M9FRLe5ZX",
    product_id: "prod_UohDHZk6HquxpH",
    payment_type: "addons",
    plan_name: "Landing Page & Web Design",
    plan_label: "Landing Page & Web Design",
    plan_description: "Design landing pages, website pages, UX/UI layouts, and responsive web mockups.",
    plan_bg: 'add_landing.jpg',
    plan_duration: 'yearly',
    plan_duration_short: '12m',
    plan_key: 'landing_page_web_design_yearly',
    plan_includes: [
      'Landing pages & website sections',
      'UX/UI layouts and wireframes',
      'Responsive web mockups',
      'Figma source files included'
    ],
    plan_type: 'add_category',
    included_categories: [
      'ONwMlLkabJA0Ti1gDCx9', //App design
      'bFaLMhkakrXr4tcPWTr0', //SaaS UI
      'EOJNqVxfop4ejFUFXHF5', //Website design
    ]
  },
  // Motion Graphics monthly
  "price_1Tp3snI0Oq9o6u7M6VsGyY1w": {
    price_id: "price_1Tp3snI0Oq9o6u7M6VsGyY1w",
    product_id: "prod_UohHqfyaJjtXvD",
    payment_type: "addons",
    plan_name: "Motion Graphics",
    plan_label: "Motion Graphics",
    plan_description: "Get animated ads, social motion posts, GIFs, simple explainers, animated graphics, and visual transitions.",
    plan_bg: 'add_motion.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'motion_graphics_monthly',
    plan_type: 'add_category',
    plan_includes: [
      'Animated social media ads',
      'GIFs and short animated loops',
      'Simple explainer animations',
      'Platform-ready export formats'
    ],
    included_categories: [
      'ZSKhz5iih44UQHB1zcbC', //2D Animated GIFs
      '0g7O1NYSPbaQjFeEHkkv', //2D Animated Logos
      'kv2sj6tFKeY7wEFJU2sx', //2D Animated Posts and Ads
      'TE1oy60eMqg8olM5dZWy' //2d Animated cover photos
    ]
  },
  // Motion Graphics quarterly
  "price_1Tp3tqI0Oq9o6u7MCgMmfess": {
    price_id: "price_1Tp3tqI0Oq9o6u7MCgMmfess",
    product_id: "prod_UohHqfyaJjtXvD",
    payment_type: "addons",
    plan_name: "Motion Graphics",
    plan_label: "Motion Graphics",
    plan_description: "Get animated ads, social motion posts, GIFs, simple explainers, animated graphics, and visual transitions.",
    plan_bg: 'add_motion.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'motion_graphics_quarterly',
    plan_type: 'add_category',
    plan_includes: [
      'Animated social media ads',
      'GIFs and short animated loops',
      'Simple explainer animations',
      'Platform-ready export formats'
    ],
    included_categories: [
      'ZSKhz5iih44UQHB1zcbC', //2D Animated GIFs
      '0g7O1NYSPbaQjFeEHkkv', //2D Animated Logos
      'kv2sj6tFKeY7wEFJU2sx', //2D Animated Posts and Ads
      'TE1oy60eMqg8olM5dZWy' //2d Animated cover photos
    ]
  },
  // Motion Graphics yearly
  "price_1Tp3u3I0Oq9o6u7MYXmAEFgO": {
    price_id: "price_1Tp3u3I0Oq9o6u7MYXmAEFgO",
    product_id: "prod_UohHqfyaJjtXvD",
    payment_type: "addons",
    plan_name: "Motion Graphics",
    plan_label: "Motion Graphics",
    plan_description: "Get animated ads, social motion posts, GIFs, simple explainers, animated graphics, and visual transitions.",
    plan_bg: 'add_motion.jpg',
    plan_duration: 'yearly',
    plan_duration_short: '12m',
    plan_key: 'motion_graphics_yearly',
    plan_type: 'add_category',
    plan_includes: [
      'Animated social media ads',
      'GIFs and short animated loops',
      'Simple explainer animations',
      'Platform-ready export formats'
    ],
    included_categories: [
      'ZSKhz5iih44UQHB1zcbC', //2D Animated GIFs
      '0g7O1NYSPbaQjFeEHkkv', //2D Animated Logos
      'kv2sj6tFKeY7wEFJU2sx', //2D Animated Posts and Ads
      'TE1oy60eMqg8olM5dZWy' //2d Animated cover photos
    ]
  },
  // Short-Form Video Editing monthly
  "price_1Tp3vfI0Oq9o6u7MqG7Wo0qM": {
    price_id: "price_1Tp3vfI0Oq9o6u7MqG7Wo0qM",
    product_id: "prod_UohKEtono393L6",
    payment_type: "addons",
    plan_name: "Short-Form Video Editing",
    plan_label: "Short-Form Video Editing",
    plan_description: "Edit existing footage into polished short-form videos with cuts, captions, music, basic graphics, and platform-ready exports.",
    plan_bg: 'add_video.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'short_form_video_editing_monthly',
    plan_type: 'add_category',
    plan_includes: [
      'Raw footage to polished social videos',
      'Captions, music, and basic graphics',
      'Instagram, TikTok & YouTube Shorts ready',
      'Fast 48–72 hr turnaround'
    ],
    included_categories: [
      'RiikSZeJjQOYdN0VJBgL', //Facebook reel
      'qktHFF6I0LfHbFMmMWfO', //Instagram reel
      '0Gw3PJmdTvrOuGwlNoIR', //Repurposing content
      'WbOVLaAfmlSdyYUFjl4W', //Tiktok reel
      'y49VcuP7KGa58jrb7baB' //Youtube short
    ]
  },
  // Short-Form Video Editing quarterly
  "price_1Tp3wDI0Oq9o6u7MhnRhi3HI": {
    price_id: "price_1Tp3wDI0Oq9o6u7MhnRhi3HI",
    product_id: "prod_UohKEtono393L6",
    payment_type: "addons",
    plan_name: "Short-Form Video Editing",
    plan_label: "Short-Form Video Editing",
    plan_description: "Edit existing footage into polished short-form videos with cuts, captions, music, basic graphics, and platform-ready exports.",
    plan_bg: 'add_video.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_key: 'short_form_video_editing_quarterly',
    plan_type: 'add_category',
    plan_includes: [
      'Raw footage to polished social videos',
      'Captions, music, and basic graphics',
      'Instagram, TikTok & YouTube Shorts ready',
      'Fast 48–72 hr turnaround'
    ],
    included_categories: [
      'RiikSZeJjQOYdN0VJBgL', //Facebook reel
      'qktHFF6I0LfHbFMmMWfO', //Instagram reel
      '0Gw3PJmdTvrOuGwlNoIR', //Repurposing content
      'WbOVLaAfmlSdyYUFjl4W', //Tiktok reel
      'y49VcuP7KGa58jrb7baB' //Youtube short
    ]
  },
  // Short-Form Video Editing yearly
  "price_1Tp3vxI0Oq9o6u7MShaAXATP": {
    price_id: "price_1Tp3vxI0Oq9o6u7MShaAXATP",
    product_id: "prod_UohKEtono393L6",
    payment_type: "addons",
    plan_name: "Short-Form Video Editing",
    plan_label: "Short-Form Video Editing",
    plan_description: "Edit existing footage into polished short-form videos with cuts, captions, music, basic graphics, and platform-ready exports.",
    plan_bg: 'add_video.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'short_form_video_editing_yearly',
    plan_type: 'add_category',
    plan_includes: [
      'Raw footage to polished social videos',
      'Captions, music, and basic graphics',
      'Instagram, TikTok & YouTube Shorts ready',
      'Fast 48–72 hr turnaround'
    ],
    included_categories: [
      'RiikSZeJjQOYdN0VJBgL', //Facebook reel
      'qktHFF6I0LfHbFMmMWfO', //Instagram reel
      '0Gw3PJmdTvrOuGwlNoIR', //Repurposing content
      'WbOVLaAfmlSdyYUFjl4W', //Tiktok reel
      'y49VcuP7KGa58jrb7baB' //Youtube short
    ]
  },
  // White label monthly
  "price_1TocjqI0Oq9o6u7MsqAD5Ap1": {
    price_id: "price_1TocjqI0Oq9o6u7MsqAD5Ap1",
    product_id: "prod_UoFEceOEhHniky",
    payment_type: "addons",
    plan_name: "White-Label Client Portal",
    plan_label: "White Label Client Portal",
    plan_description: "White-label creative portal for your agency. Manage your team, clients, projects, and revisions in one branded workflow.",
    plan_bg: 'add_white_label.jpg',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_key: 'white_label_monthly',
    plan_includes: [
      'Branded client-facing workspace',
      'Agency logo and custom domain',
      'Client project tracking and approvals',
      'White-label revision workflows'
    ],
  },
  // White label quarterly
  "price_1Tocl9I0Oq9o6u7Ml8QbaW8h": {
    price_id: "price_1Tocl9I0Oq9o6u7Ml8QbaW8h",
    product_id: "prod_UoFEceOEhHniky",
    payment_type: "addons",
    plan_name: "White-Label Client Portal",
    plan_label: "White Label Client Portal",
    plan_description: "White-label creative portal for your agency. Manage your team, clients, projects, and revisions in one branded workflow.",
    plan_bg: 'add_white_label.jpg',
    plan_duration: 'quarterly',
    plan_duration_short: 'q',
    plan_key: 'white_label_quarterly',
    plan_includes: [
      'Branded client-facing workspace',
      'Agency logo and custom domain',
      'Client project tracking and approvals',
      'White-label revision workflows'
    ],
  },
  // White label yearly
  "price_1ToclWI0Oq9o6u7McKPPicAC": {
    price_id: "price_1ToclWI0Oq9o6u7McKPPicAC",
    product_id: "prod_UoFEceOEhHniky",
    payment_type: "addons",
    plan_name: "White-Label Client Portal",
    plan_label: "White Label Client Portal",
    plan_description: "White-label creative portal for your agency. Manage your team, clients, projects, and revisions in one branded workflow.",
    plan_bg: 'add_white_label.jpg',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_key: 'white_label_yearly',
    plan_includes: [
      'Branded client-facing workspace',
      'Agency logo and custom domain',
      'Client project tracking and approvals',
      'White-label revision workflows'
    ],
  },
}

export const list_delivery = [
  {
    images: '<svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M8.71795 0H40.5128C45.3333 0 49.2308 3.89744 49.2308 8.71795V39.2821C49.2308 44.1026 45.3333 48 40.5128 48H8.71795C3.89744 48 0 44.1026 0 39.2821V8.71795C0 3.89744 3.89744 0 8.71795 0Z" fill="#49021F"/><path d="M17.8869 12.554V33.6822C17.8869 33.9078 17.7843 34.0104 17.5997 34.0104H13.5792C13.3946 34.0104 13.3125 33.9078 13.3125 33.6822V12.554C13.3125 12.3694 13.4151 12.2873 13.5997 12.2873H17.5997C17.7228 12.2668 17.8458 12.3488 17.8663 12.4924C17.8869 12.5129 17.8869 12.5335 17.8869 12.554Z" fill="#FF3366"/> <path d="M29.7441 34.2561C28.2261 34.2766 26.7082 33.9689 25.3338 33.333C24.0415 32.7381 22.9749 31.7535 22.2364 30.5432C21.4774 29.2919 21.1082 27.733 21.1082 25.8663C21.0877 24.3484 21.4774 22.8509 22.2364 21.5381C23.0159 20.2048 24.1441 19.0971 25.4979 18.3586C26.9338 17.5586 28.6569 17.1689 30.6877 17.1689C30.7902 17.1689 30.9338 17.1689 31.1184 17.1894C31.3031 17.2099 31.5082 17.2099 31.7543 17.2304V10.7484C31.7543 10.6048 31.8159 10.5227 31.9595 10.5227H36.1236C36.2261 10.5022 36.3082 10.5843 36.3287 10.6663V10.7073V30.2355C36.3287 30.6048 36.3492 31.015 36.3697 31.4663C36.4108 31.8971 36.4313 32.3073 36.4518 32.6561C36.4518 32.7996 36.3902 32.9227 36.2467 32.9843C35.18 33.4355 34.0518 33.7637 32.9031 33.9689C31.8774 34.1535 30.8108 34.2561 29.7441 34.2561ZM31.7543 30.1535V21.1278C31.5697 21.0868 31.3851 21.0458 31.2005 21.0253C30.9749 21.0048 30.7492 20.9843 30.5236 20.9843C29.7236 20.9843 28.9236 21.1484 28.2056 21.5176C27.5082 21.8663 26.9133 22.3791 26.462 23.0355C26.0108 23.6919 25.7851 24.574 25.7851 25.6407C25.7646 26.3586 25.8877 27.0766 26.1338 27.7535C26.339 28.3073 26.6467 28.7996 27.0569 29.2099C27.4467 29.5791 27.9184 29.8663 28.4518 30.0304C29.0056 30.215 29.58 30.2971 30.1543 30.2971C30.462 30.2971 30.7492 30.2766 31.0159 30.2561C31.2826 30.2766 31.5287 30.2355 31.7543 30.1535Z" fill="#FF3366"/></g></svg>',
    name: 'Indesign',
    value: 'INDD',
    disabled: false
  },
  {
    images: '<svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M8.71795 0H40.5128C45.3333 0 49.2308 3.89744 49.2308 8.71795V39.2821C49.2308 44.1026 45.3333 48 40.5128 48H8.71795C3.89744 48 0 44.1026 0 39.2821V8.71795C0 3.89744 3.89744 0 8.71795 0Z" fill="#330000"/><path d="M23.7953 28.7183H16.1646L14.6056 33.5388C14.5646 33.7234 14.4005 33.8465 14.2159 33.826H10.3594C10.1338 33.826 10.0723 33.7029 10.1338 33.4567L16.7389 14.4414C16.8005 14.2362 16.862 14.0106 16.9441 13.7644C17.0261 13.3337 17.0671 12.8824 17.0671 12.4311C17.0466 12.3285 17.1287 12.226 17.2312 12.2055H22.5441C22.7082 12.2055 22.7902 12.267 22.8107 12.3696L30.2979 33.4978C30.3594 33.7234 30.2979 33.826 30.0928 33.826H25.8056C25.662 33.8465 25.5184 33.7439 25.4774 33.6003L23.7953 28.7183ZM17.3543 24.5542H22.5646C22.4415 24.1234 22.2774 23.6106 22.0928 23.0773C21.9082 22.5234 21.7235 21.9285 21.5389 21.3132C21.3338 20.6773 21.1492 20.0619 20.9441 19.426C20.7389 18.7901 20.5543 18.1952 20.3902 17.6003C20.2261 17.026 20.0825 16.4926 19.9389 16.0003H19.8979C19.7133 16.8824 19.4876 17.7644 19.2005 18.6465C18.8928 19.6311 18.5851 20.6567 18.2569 21.6824C17.9697 22.7285 17.662 23.6926 17.3543 24.5542ZM34.8723 15.7952C34.1953 15.8157 33.5389 15.549 33.0466 15.0773C32.5748 14.5644 32.3287 13.8875 32.3492 13.1901C32.3287 12.4926 32.5953 11.8362 33.0877 11.3644C33.58 10.8926 34.2364 10.6465 34.9133 10.6465C35.7133 10.6465 36.3287 10.8926 36.78 11.3644C37.2312 11.8567 37.4774 12.5132 37.4569 13.1901C37.4774 13.8875 37.2312 14.5644 36.7389 15.0773C36.2671 15.5696 35.5697 15.8362 34.8723 15.7952ZM32.5748 33.6003V17.8055C32.5748 17.6003 32.6569 17.5183 32.8415 17.5183H36.903C37.0876 17.5183 37.1697 17.6208 37.1697 17.8055V33.6003C37.1697 33.826 37.0876 33.9285 36.903 33.9285H32.8825C32.6774 33.9285 32.5748 33.8055 32.5748 33.6003Z" fill="#FF9A00"/></g></svg>',
    name: 'Illustrator',
    value: 'AI',
    disabled: false
  },
  {
    images: '<svg width="50" height="48" viewBox="0 0 50 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M8.71795 0H40.5128C45.3333 0 49.2308 3.89744 49.2308 8.71795V39.2821C49.2308 44.1026 45.3333 48 40.5128 48H8.71795C3.89744 48 0 44.1026 0 39.2821V8.71795C0 3.89744 3.89744 0 8.71795 0Z" fill="#001E36"/><path d="M11.0762 33.6615V12.5538C11.0762 12.4102 11.1377 12.3282 11.2813 12.3282C11.63 12.3282 11.9582 12.3282 12.43 12.3076C12.9223 12.2871 13.4351 12.2871 13.989 12.2666C14.5428 12.2461 15.1377 12.2461 15.7736 12.2256C16.4095 12.2051 17.0249 12.2051 17.6403 12.2051C19.3223 12.2051 20.7172 12.4102 21.8659 12.841C22.8916 13.1897 23.8351 13.7641 24.6146 14.523C25.271 15.1794 25.7839 15.9794 26.1121 16.8615C26.4198 17.723 26.5839 18.6051 26.5839 19.5282C26.5839 21.2923 26.1736 22.7487 25.3531 23.8974C24.5326 25.0461 23.3839 25.9076 22.0505 26.3999C20.6557 26.9128 19.1172 27.0974 17.4351 27.0974C16.9428 27.0974 16.6146 27.0974 16.4095 27.0769C16.2044 27.0564 15.9172 27.0564 15.5275 27.0564V33.641C15.548 33.7846 15.4454 33.9076 15.3018 33.9282C15.2813 33.9282 15.2608 33.9282 15.2198 33.9282H11.3223C11.1582 33.9282 11.0762 33.8461 11.0762 33.6615ZM15.548 16.2871V23.1794C15.8351 23.2 16.1018 23.2205 16.348 23.2205H17.4351C18.2351 23.2205 19.0351 23.0974 19.7941 22.8512C20.4505 22.6666 21.0249 22.2769 21.4762 21.7641C21.9069 21.2512 22.1121 20.5538 22.1121 19.6512C22.1326 19.0153 21.9685 18.3794 21.6403 17.8256C21.2916 17.2923 20.7992 16.882 20.2044 16.6564C19.4454 16.3487 18.6249 16.2256 17.7839 16.2461C17.2505 16.2461 16.7787 16.2461 16.389 16.2666C15.9787 16.2461 15.6916 16.2666 15.548 16.2871Z" fill="#31A8FF"/><path d="M39.3831 21.9279C38.7677 21.5997 38.1113 21.374 37.4139 21.2305C36.6549 21.0664 35.896 20.9638 35.1165 20.9638C34.7062 20.9433 34.2754 21.0048 33.8857 21.1074C33.619 21.1689 33.3934 21.3125 33.2498 21.5176C33.1472 21.6817 33.0857 21.8869 33.0857 22.0715C33.0857 22.2561 33.1677 22.4407 33.2908 22.6048C33.4754 22.8305 33.7216 23.0151 33.9883 23.1587C34.4601 23.4048 34.9524 23.6305 35.4447 23.8356C36.5524 24.2048 37.619 24.7176 38.6036 25.333C39.2806 25.7638 39.8344 26.3381 40.2242 27.0356C40.5524 27.692 40.7165 28.4099 40.696 29.1484C40.7165 30.1125 40.4293 31.0766 39.896 31.8766C39.3216 32.6971 38.5216 33.333 37.5985 33.7022C36.5934 34.133 35.3626 34.3587 33.8857 34.3587C32.9421 34.3587 32.019 34.2766 31.096 34.092C30.378 33.9689 29.6601 33.7433 29.0036 33.4356C28.8601 33.3535 28.7575 33.2099 28.778 33.0458V29.4766C28.778 29.4151 28.7985 29.333 28.8601 29.292C28.9216 29.251 28.9831 29.2715 29.0447 29.3125C29.8447 29.7843 30.6857 30.1125 31.5883 30.3176C32.3677 30.5228 33.1883 30.6253 34.0088 30.6253C34.7883 30.6253 35.3421 30.5228 35.7113 30.3381C36.0395 30.1946 36.2652 29.8458 36.2652 29.4766C36.2652 29.1894 36.1011 28.9228 35.7729 28.6561C35.4447 28.3894 34.7677 28.0817 33.7626 27.692C32.7165 27.3228 31.7524 26.8305 30.8498 26.2151C30.2139 25.7638 29.6806 25.1689 29.2908 24.4715C28.9626 23.8151 28.7985 23.0971 28.819 22.3792C28.819 21.4971 29.0652 20.6561 29.5165 19.8971C30.0293 19.0766 30.7883 18.4202 31.6703 18.0099C32.6344 17.5176 33.8447 17.292 35.3011 17.292C36.1421 17.292 37.0036 17.3535 37.8447 17.4766C38.4601 17.5587 39.0549 17.7228 39.6088 17.9484C39.6908 17.9689 39.7729 18.051 39.8139 18.133C39.8344 18.2151 39.8549 18.2971 39.8549 18.3792V21.7228C39.8549 21.8048 39.8139 21.8869 39.7524 21.9279C39.5677 21.9689 39.4652 21.9689 39.3831 21.9279Z" fill="#31A8FF"/></g></svg>',
    name: 'Photoshop',
    value: 'PSD',
    disabled: false
  },
  {
    images: '<svg width="50" height="48" viewBox="0 0 240 234" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.4903 0.187195H196.669C219.735 0.187195 239.16 18.8136 239.16 42.7752V191.318C239.16 214.438 220.576 233.906 196.669 233.906H42.4903C19.3307 233.813 0 215.186 0 191.318V42.6816C0 18.8136 18.5837 0.187195 42.4903 0.187195Z" fill="#B30B00"/><path d="M190.693 135.252C179.486 123.271 148.949 128.513 141.572 129.262C131.113 118.778 123.735 106.891 120.747 102.398C124.482 91.1664 127.471 78.5304 127.471 66.5496C127.471 55.3176 122.988 44.1792 111.128 44.1792C106.646 44.1792 102.911 46.4256 100.669 50.1696C95.4397 59.1552 97.6809 77.0328 105.899 95.6592C101.416 109.138 93.9455 129.262 85.0739 144.893C73.1206 149.386 47.0661 161.273 44.8249 174.751C44.0778 178.495 45.572 182.988 48.5603 185.234C51.5486 188.23 55.284 188.978 59.0195 188.978C74.6148 188.978 90.3035 167.357 101.51 147.888C110.475 144.893 124.576 140.4 138.77 138.154C155.113 153.13 170.054 155.282 177.525 155.282C187.984 155.282 191.72 150.79 193.121 147.046C195.082 143.489 193.681 138.247 190.693 135.252ZM180.233 142.74C179.486 145.735 175.751 148.73 169.027 147.233C160.809 144.986 153.432 141.242 147.455 136.001C152.685 135.252 165.292 133.754 174.257 135.252C177.245 136.001 180.981 138.247 180.233 142.74ZM107.953 53.1648C108.7 51.6672 110.195 50.9184 111.689 50.9184C115.424 50.9184 116.171 55.4112 116.171 59.1552C115.424 68.1408 113.93 77.7816 110.942 86.0184C104.965 69.6384 105.712 57.6576 107.953 53.1648ZM107.206 137.498C110.942 130.759 115.424 118.123 116.918 113.63C120.654 120.37 127.377 127.858 130.366 131.508C131.113 130.853 117.665 133.754 107.206 137.498ZM81.8988 154.721C71.5331 171.101 61.821 181.584 55.8444 181.584C55.0973 181.584 53.6031 181.584 52.856 180.835C52.1089 179.338 51.3619 177.84 52.1089 176.342C52.856 170.352 64.8093 162.115 81.8988 154.721Z" fill="white"/></svg>',
    name: 'Adobe Acrobat Reader',
    value: 'PDF',
    disabled: false
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="48" viewBox="0 0 50 48" fill="none"><g clip-path="url(#clip0_3521_3757)"><path d="M29.7683 26.4L26.3336 0H26.0771C13.5877 0.0382172 3.47201 10.6407 3.43555 23.7312V24L29.7683 26.4Z" fill="#ED6C47"/><path d="M26.5885 0H26.332V24L37.781 28.8L49.2301 24V23.7312C49.1936 10.6407 39.078 0.0382172 26.5885 0Z" fill="#FF8F6B"/><path d="M49.2316 24V24.264C49.1958 37.3574 39.0777 47.9624 26.5855 48H26.0817C13.5895 47.9624 3.47139 37.3574 3.43555 24.264V24H49.2316Z" fill="#D35230"/><path opacity="0.1" d="M27.4785 11.7956V37.4036C27.4728 38.2935 26.9583 39.0928 26.1733 39.4316C25.9234 39.5424 25.6547 39.5996 25.3833 39.5996H8.83951C8.51894 39.2156 8.20983 38.8076 7.92359 38.3996C5.00672 34.3212 3.43178 29.3607 3.43557 24.2636V23.7356C3.42888 19.1382 4.71081 14.64 7.12216 10.7996C7.37403 10.3916 7.63735 9.98361 7.92359 9.59961H25.3833C26.5368 9.60877 27.4698 10.5866 27.4785 11.7956Z" fill="black"/><path opacity="0.2" d="M26.3336 12.9958V38.6038C26.3336 38.8883 26.2791 39.1698 26.1733 39.4318C25.8501 40.2546 25.0874 40.7938 24.2384 40.7998H9.88138C9.51914 40.4144 9.17157 40.014 8.83951 39.5998C8.51894 39.2158 8.20983 38.8078 7.92359 38.3998C5.00672 34.3214 3.43178 29.3608 3.43557 24.2638V23.7358C3.42888 19.1384 4.71081 14.6402 7.12216 10.7998H24.2384C25.392 10.8089 26.3249 11.7868 26.3336 12.9958Z" fill="black"/><path opacity="0.2" d="M26.3336 12.9958V36.2038C26.3249 37.4128 25.3919 38.3906 24.2385 38.3998H7.92359C5.00672 34.3214 3.43178 29.3608 3.43557 24.2638V23.7358C3.42888 19.1384 4.71081 14.6402 7.12216 10.7998H24.2384C25.3919 10.8089 26.3249 11.7868 26.3336 12.9958Z" fill="black"/><path opacity="0.2" d="M25.1887 12.9958V36.2038C25.18 37.4128 24.247 38.3906 23.0936 38.3998H7.92359C5.00672 34.3214 3.43178 29.3608 3.43557 24.2638V23.7358C3.42888 19.1384 4.71081 14.6402 7.12216 10.7998H23.0935C24.247 10.8089 25.18 11.7868 25.1887 12.9958Z" fill="black"/><path d="M2.09859 10.7998H23.0892C24.2483 10.7998 25.1878 11.7846 25.1878 12.9994V35.0002C25.1878 36.215 24.2482 37.1998 23.0892 37.1998H2.09859C0.939589 37.1998 0 36.215 0 35.0002V12.9994C0 11.7846 0.939589 10.7998 2.09859 10.7998Z" fill="url(#paint0_linear_3521_3757)"/><path d="M12.8237 16.667C14.1901 16.5704 15.5448 16.9864 16.6454 17.8407C17.5634 18.6996 18.0539 19.9531 17.9758 21.2402C17.9908 22.135 17.7633 23.0159 17.3198 23.7806C16.8707 24.5322 16.2238 25.1315 15.457 25.5063C14.5804 25.9336 13.622 26.1446 12.6554 26.123H10.0004V31.295H7.28125V16.667H12.8237ZM9.99812 23.8887H12.3383C13.0802 23.9458 13.8163 23.7156 14.4072 23.2419C14.8958 22.7505 15.152 22.0576 15.1067 21.3495C15.1067 19.7375 14.2129 18.9315 12.4253 18.9315H9.99814V23.8887H9.99812Z" fill="white"/></g><defs><linearGradient id="paint0_linear_3521_3757" x1="4.37564" y1="9.08108" x2="21.998" y2="38.2009" gradientUnits="userSpaceOnUse"><stop stop-color="#CA4C28"/><stop offset="0.5" stop-color="#C5401E"/><stop offset="1" stop-color="#B62F14"/></linearGradient><clipPath id="clip0_3521_3757"><rect width="49.2308" height="48" fill="white"/></clipPath></defs></svg>',
    name: 'Microsoft PowerPoint',
    value: 'PPTX',
    disabled: false
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="48" viewBox="0 0 50 48" fill="none"><g clip-path="url(#clip0_3521_3777)"><path d="M47.4664 0H13.8818C12.7228 0 11.7832 0.984795 11.7832 2.19961V12L31.2465 18L49.565 12V2.19961C49.565 0.984795 48.6254 0 47.4664 0Z" fill="#41A5EE"/><path d="M49.565 12H11.7832V24L31.2465 27.6L49.565 24V12Z" fill="#2B7CD3"/><path d="M11.7832 24V36L30.1016 38.4L49.565 36V24H11.7832Z" fill="#185ABD"/><path d="M13.8818 48H47.4664C48.6254 48 49.565 47.0152 49.565 45.8004V36H11.7832V45.8004C11.7832 47.0152 12.7228 48 13.8818 48Z" fill="#103F91"/><path opacity="0.1" d="M25.7132 9.59961H11.7832V39.5996H25.7132C26.8707 39.5957 27.8081 38.6132 27.8118 37.4V11.7992C27.8081 10.5861 26.8707 9.60356 25.7132 9.59961Z" fill="black"/><path opacity="0.2" d="M24.5683 10.7998H11.7832V40.7998H24.5683C25.7258 40.7959 26.6632 39.8134 26.6669 38.6002V12.9994C26.6632 11.7862 25.7258 10.8038 24.5683 10.7998Z" fill="black"/><path opacity="0.2" d="M24.5683 10.7998H11.7832V38.3998H24.5683C25.7258 38.3959 26.6632 37.4134 26.6669 36.2002V12.9994C26.6632 11.7862 25.7258 10.8038 24.5683 10.7998Z" fill="black"/><path opacity="0.2" d="M23.4234 10.7998H11.7832V38.3998H23.4234C24.5809 38.3959 25.5183 37.4134 25.522 36.2002V12.9994C25.5183 11.7862 24.5809 10.8038 23.4234 10.7998Z" fill="black"/><path d="M2.4326 10.7998H23.4232C24.5822 10.7998 25.5218 11.7846 25.5218 12.9994V35.0002C25.5218 36.215 24.5822 37.1998 23.4232 37.1998H2.4326C1.27356 37.1998 0.333984 36.215 0.333984 35.0002V12.9994C0.333984 11.7846 1.27356 10.7998 2.4326 10.7998Z" fill="url(#paint0_linear_3521_3777)"/><path d="M8.94526 27.6697C8.98648 28.0093 9.01395 28.3045 9.02654 28.5577H9.07461C9.09293 28.3177 9.13109 28.0285 9.1891 27.6901C9.24712 27.3517 9.29941 27.0657 9.34596 26.8321L11.5533 16.8505H14.4076L16.6974 26.6821C16.8304 27.2934 16.9257 27.9131 16.9825 28.5373H17.0203C17.0629 27.9326 17.1425 27.3314 17.2584 26.7373L19.0845 16.8457H21.6823L18.4743 31.1497H15.4391L13.2638 21.6769C13.2009 21.4045 13.1287 21.0481 13.0497 20.6101C12.9707 20.1721 12.9215 19.8517 12.902 19.6501H12.8643C12.8391 19.8829 12.7898 20.2285 12.7166 20.6869C12.6433 21.1453 12.5845 21.4845 12.5402 21.7045L10.4954 31.1473H7.40876L4.18359 16.8505H6.8283L8.817 26.8525C8.86168 27.0577 8.90404 27.3313 8.94526 27.6697Z" fill="white"/></g><defs><linearGradient id="paint0_linear_3521_3777" x1="4.70962" y1="9.08108" x2="22.332" y2="38.2009" gradientUnits="userSpaceOnUse"><stop stop-color="#2368C4"/><stop offset="0.5" stop-color="#1A5DBE"/><stop offset="1" stop-color="#1146AC"/></linearGradient><clipPath id="clip0_3521_3777"><rect width="49.2308" height="48" fill="white" transform="translate(0.333984)"/></clipPath></defs></svg>',
    name: 'Microsoft Word',
    value: 'DOCX',
    disabled: false
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" width="37" height="48" viewBox="0 0 37 48" fill="none"><path d="M22.7523 0H3.73351C1.88735 0 0.376953 1.47168 0.376953 3.27168V44.7283C0.376953 46.5283 1.88637 48 3.73252 48H32.819C34.6652 48 36.1746 46.5283 36.1746 44.7283V13.0877L28.3381 7.63104L22.7523 0Z" fill="#F4B400"/><path d="M25.5497 21.8164H11.0108C10.0873 21.8164 9.32812 22.5566 9.32812 23.457V37.641C9.32812 38.5415 10.0873 39.2817 11.0108 39.2817H25.5585C26.4821 39.2817 27.2412 38.5415 27.2412 37.641V23.457C27.2324 22.5566 26.4722 21.8164 25.5497 21.8164ZM24.9914 34.3598H11.5691V26.7191H24.9924V34.3598H24.9914Z" fill="#F1F1F1"/><path d="M23.7422 12.1318L36.1848 24.2624V13.088L23.7422 12.1318Z" fill="url(#paint0_linear_3521_6915)"/><path d="M22.7539 0.00390625V9.81991C22.7539 11.6295 24.2535 13.0916 26.1095 13.0916H36.1772L22.7539 0.00390625Z" fill="#FADA80"/><path d="M22.752 0V0.27168L35.9054 13.0877H36.1851L22.752 0Z" fill="white" fill-opacity="0.1"/><path d="M3.73351 0C1.88735 0 0.376953 1.47168 0.376953 3.27168V3.54336C0.376953 1.74336 1.88637 0.27168 3.73252 0.27168H22.7514V0H3.73351Z" fill="white" fill-opacity="0.2"/><path d="M32.8279 47.7287H3.73252C1.88637 47.7287 0.376953 46.257 0.376953 44.457V44.7287C0.376953 46.5287 1.88637 48.0004 3.73252 48.0004H32.819C34.6652 48.0004 36.1746 46.5287 36.1746 44.7287V44.457C36.1845 46.257 34.6741 47.7287 32.8279 47.7287Z" fill="#BF360C" fill-opacity="0.2"/><path d="M26.1173 13.0881C24.2613 13.0881 22.7617 11.626 22.7617 9.81641V10.0881C22.7617 11.8977 24.2613 13.3598 26.1173 13.3598H36.185V13.0881H26.1173Z" fill="#BF360C" fill-opacity="0.1"/><path d="M22.7523 0H3.73351C1.88735 0 0.376953 1.47168 0.376953 3.27168V44.7283C0.376953 46.5283 1.88637 48 3.73252 48H32.819C34.6652 48 36.1746 46.5283 36.1746 44.7283V13.0877L22.7523 0Z" fill="url(#paint1_radial_3521_6915)"/><defs><linearGradient id="paint0_linear_3521_6915" x1="29.9631" y1="13.1771" x2="29.9631" y2="24.2683" gradientUnits="userSpaceOnUse"><stop stop-color="#BF360C" stop-opacity="0.2"/><stop offset="1" stop-color="#BF360C" stop-opacity="0.02"/></linearGradient><radialGradient id="paint1_radial_3521_6915" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(1.51384 1.30121) scale(57.734 56.2907)"><stop stop-color="white" stop-opacity="0.1"/><stop offset="1" stop-color="white" stop-opacity="0"/></radialGradient></defs></svg>',
    name: 'Google Slides',
    value: 'SLIDES',
    disabled: false
  },
  // {
  //   images: '<svg xmlns="http://www.w3.org/2000/svg" width="37" height="48" viewBox="0 0 37 48" fill="none"><path d="M33.1604 48H4.06953C2.22338 48 0.712891 46.5273 0.712891 44.7273V3.27273C0.712891 1.47273 2.22338 0 4.06953 0H24.2094L36.5171 12V44.7273C36.5171 46.5273 35.0066 48 33.1604 48Z" fill="#3086F6"/><path d="M24.209 0L36.5167 12H24.209V0Z" fill="#0C67D6"/><path d="M28.6848 21.2732H8.54492V18.5459H28.6848V21.2732ZM28.6848 25.0914H8.54492V27.8186H28.6848V25.0914ZM23.0904 31.6368H8.54492V34.3641H23.0904V31.6368Z" fill="#FDFFFF"/></svg>',
  //   name: 'Google Docs',
  //   value: 'DOC',
  //   disabled: false
  // },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="48" viewBox="0 0 50 48" fill="none"><path d="M9.05193 0H40.8468C45.6673 0 49.5648 3.89744 49.5648 8.71795V39.2821C49.5648 44.1026 45.6673 48 40.8468 48H9.05193C4.23142 48 0.333984 44.1026 0.333984 39.2821V8.71795C0.333984 3.89744 4.23142 0 9.05193 0Z" fill="#470137"/><path d="M26.2216 12.6153L20.0678 22.7692L26.6319 33.5384C26.6729 33.6204 26.6934 33.7025 26.6729 33.7845C26.6524 33.8666 26.5703 33.8051 26.4472 33.8256H21.7498C21.4216 33.8256 21.196 33.8051 21.0524 33.5999C20.6216 32.7384 20.1703 31.8974 19.7395 31.0358C19.3088 30.1948 18.837 29.3333 18.3447 28.4512C17.8524 27.5692 17.3601 26.6871 16.8678 25.7845H16.8267C16.396 26.6666 15.9242 27.5486 15.4524 28.4307C14.9806 29.3127 14.5088 30.1948 14.0575 31.0563C13.5857 31.9179 13.1139 32.7999 12.6421 33.641C12.5601 33.8461 12.396 33.8666 12.1703 33.8666H7.6575C7.57545 33.8666 7.51391 33.9076 7.51391 33.8051C7.49339 33.723 7.51391 33.6409 7.55493 33.5794L13.9344 23.1179L7.71903 12.5948C7.6575 12.5127 7.63698 12.4307 7.67801 12.3897C7.71903 12.3281 7.80109 12.3076 7.88314 12.3076H12.5395C12.6421 12.3076 12.7447 12.3281 12.8267 12.3486C12.9088 12.3897 12.9703 12.4512 13.0319 12.5333C13.4216 13.4153 13.8729 14.2974 14.3447 15.1794C14.837 16.0615 15.3088 16.923 15.8216 17.7845C16.3139 18.6461 16.7652 19.5076 17.196 20.3897H17.237C17.6678 19.4871 18.119 18.6051 18.5703 17.7435C19.0216 16.882 19.4934 16.0204 19.9652 15.1589C20.437 14.2974 20.8883 13.4153 21.3395 12.5743C21.3601 12.4922 21.4011 12.4102 21.4626 12.3692C21.5447 12.3281 21.6267 12.3076 21.7293 12.3281H26.0575C26.1601 12.3076 26.2626 12.3692 26.2831 12.4717C26.3037 12.4922 26.2626 12.5743 26.2216 12.6153Z" fill="#FF61F6"/><path d="M35.6992 34.2561C34.1812 34.2766 32.6633 33.9689 31.2889 33.333C29.9966 32.7381 28.9299 31.7535 28.1915 30.5432C27.4325 29.2919 27.0633 27.733 27.0633 25.8663C27.0428 24.3484 27.4325 22.8509 28.1915 21.5381C28.971 20.2048 30.0992 19.0971 31.453 18.3586C32.8889 17.5586 34.612 17.1689 36.6428 17.1689C36.7453 17.1689 36.8889 17.1689 37.0735 17.1894C37.2581 17.2099 37.4633 17.2099 37.7094 17.2304V10.7484C37.7094 10.6048 37.771 10.5227 37.9146 10.5227H42.0787C42.1812 10.5022 42.2633 10.5843 42.2838 10.6663C42.2838 10.6868 42.2838 10.7073 42.2838 10.7073V30.2355C42.2838 30.6048 42.3043 31.015 42.3248 31.4663C42.3658 31.8971 42.3863 32.3073 42.4069 32.6561C42.4069 32.7996 42.3453 32.9227 42.2017 32.9843C41.1351 33.4355 40.0069 33.7637 38.8581 33.9689C37.812 34.1535 36.7658 34.2561 35.6992 34.2561ZM37.7094 30.1535V21.1278C37.5248 21.0868 37.3402 21.0458 37.1556 21.0253C36.9299 21.0048 36.7043 20.9843 36.4787 20.9843C35.6787 20.9843 34.8787 21.1484 34.1607 21.5176C33.4633 21.8663 32.8684 22.3791 32.4171 23.0355C31.9658 23.6919 31.7402 24.574 31.7402 25.6407C31.7197 26.3586 31.8428 27.0766 32.0889 27.7535C32.294 28.3073 32.6017 28.7996 33.012 29.2099C33.4017 29.5791 33.8735 29.8663 34.4069 30.0304C34.9607 30.215 35.5351 30.2971 36.1094 30.2971C36.4171 30.2971 36.7043 30.2766 36.971 30.2561C37.2376 30.2766 37.4633 30.2355 37.7094 30.1535Z" fill="#FF61F6"/></svg>',
    name: 'Adobe XD',
    value: 'XD',
    disabled: false
  },
  {
    images: '<svg width="48" height="48" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.375 18.75C14.5527 18.75 18.75 14.5527 18.75 9.375C18.75 4.19733 14.5527 0 9.375 0C4.19733 0 0 4.19733 0 9.375C0 14.5527 4.19733 18.75 9.375 18.75Z" fill="#7D2AE7"/><path d="M9.375 18.75C14.5527 18.75 18.75 14.5527 18.75 9.375C18.75 4.19733 14.5527 0 9.375 0C4.19733 0 0 4.19733 0 9.375C0 14.5527 4.19733 18.75 9.375 18.75Z" fill="url(#paint0_radial_7270_16934)"/><path d="M9.375 18.75C14.5527 18.75 18.75 14.5527 18.75 9.375C18.75 4.19733 14.5527 0 9.375 0C4.19733 0 0 4.19733 0 9.375C0 14.5527 4.19733 18.75 9.375 18.75Z" fill="url(#paint1_radial_7270_16934)"/><path d="M9.375 18.75C14.5527 18.75 18.75 14.5527 18.75 9.375C18.75 4.19733 14.5527 0 9.375 0C4.19733 0 0 4.19733 0 9.375C0 14.5527 4.19733 18.75 9.375 18.75Z" fill="url(#paint2_radial_7270_16934)"/><path d="M9.375 18.75C14.5527 18.75 18.75 14.5527 18.75 9.375C18.75 4.19733 14.5527 0 9.375 0C4.19733 0 0 4.19733 0 9.375C0 14.5527 4.19733 18.75 9.375 18.75Z" fill="url(#paint3_radial_7270_16934)"/><path d="M13.4221 11.2978C13.3447 11.2978 13.2766 11.3631 13.2057 11.5058C12.4056 13.1283 11.0236 14.2763 9.42442 14.2763C7.57528 14.2763 6.43015 12.607 6.43015 10.301C6.43015 6.39474 8.60661 4.13622 10.5183 4.13622C11.4116 4.13622 11.9571 4.69759 11.9571 5.59093C11.9571 6.65118 11.3547 7.21254 11.3547 7.58648C11.3547 7.75433 11.4591 7.85597 11.6662 7.85597C12.498 7.85597 13.4743 6.90016 13.4743 5.54989C13.4743 4.24066 12.3348 3.27832 10.4231 3.27832C7.26382 3.27832 4.45605 6.20731 4.45605 10.2599C4.45605 13.3969 6.24739 15.4699 9.01133 15.4699C11.945 15.4699 13.6412 12.5511 13.6412 11.6037C13.6412 11.3939 13.534 11.2978 13.4221 11.2978Z" fill="white"/><defs><radialGradient id="paint0_radial_7270_16934" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.6218 16.6185) rotate(-49.416) scale(14.5015)"><stop stop-color="#6420FF"/><stop offset="1" stop-color="#6420FF" stop-opacity="0"/></radialGradient><radialGradient id="paint1_radial_7270_16934" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4.96378 2.13154) rotate(54.703) scale(16.3532)"><stop stop-color="#00C4CC"/><stop offset="1" stop-color="#00C4CC" stop-opacity="0"/></radialGradient><radialGradient id="paint2_radial_7270_16934" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(3.62171 16.6184) rotate(-45.1954) scale(14.326 6.58871)"><stop stop-color="#6420FF"/><stop offset="1" stop-color="#6420FF" stop-opacity="0"/></radialGradient><radialGradient id="paint3_radial_7270_16934" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.66776 2.52632) rotate(66.5198) scale(14.7618 24.7293)"><stop stop-color="#00C4CC" stop-opacity="0.725916"/><stop offset="0.0001" stop-color="#00C4CC"/><stop offset="1" stop-color="#00C4CC" stop-opacity="0"/></radialGradient></defs></svg>',
    name: 'Canva',
    value: 'CANVA',
    disabled: true
  },
  {
    images: '<svg width="48" height="48" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_7270_17125)"><path d="M3.40545 1.51128e-06H15.8253C16.2726 -0.000420099 16.7157 0.0873767 17.129 0.258367C17.5424 0.429358 17.918 0.680185 18.2343 0.996494C18.5506 1.3128 18.8014 1.68838 18.9724 2.10174C19.1434 2.5151 19.2312 2.95812 19.2308 3.40545V15.3446C19.2312 15.7919 19.1434 16.2349 18.9724 16.6483C18.8014 17.0616 18.5506 17.4372 18.2343 17.7535C17.918 18.0698 17.5424 18.3206 17.129 18.4916C16.7157 18.6626 16.2726 18.7504 15.8253 18.75H3.40545C2.95812 18.7504 2.5151 18.6626 2.10174 18.4916C1.68838 18.3206 1.3128 18.0698 0.996494 17.7535C0.680185 17.4372 0.429358 17.0616 0.258367 16.6483C0.0873767 16.2349 -0.000420099 15.7919 1.51128e-06 15.3446V3.40545C-0.000420099 2.95812 0.0873767 2.5151 0.258367 2.10174C0.429358 1.68838 0.680185 1.3128 0.996494 0.996494C1.3128 0.680185 1.68838 0.429358 2.10174 0.258367C2.5151 0.0873767 2.95812 -0.000420099 3.40545 1.51128e-06Z" fill="#000B1D"/><path d="M7.61258 15.3843C8.71892 15.3843 9.61579 14.4875 9.61579 13.3811V11.3779H7.61258C6.50624 11.3779 5.60938 12.2748 5.60938 13.3811C5.60938 14.4875 6.50624 15.3843 7.61258 15.3843Z" fill="#0ACF83"/><path d="M5.60938 9.37528C5.60938 8.26894 6.50624 7.37207 7.61258 7.37207H9.61579V11.3785H7.61258C6.50624 11.3785 5.60938 10.4816 5.60938 9.37528Z" fill="#A259FF"/><path d="M5.60938 5.36844C5.60938 4.2621 6.50624 3.36523 7.61258 3.36523H9.61579V7.37164H7.61258C6.50624 7.37164 5.60938 6.47478 5.60938 5.36844Z" fill="#F24E1E"/><path d="M9.61621 3.36523H11.6194C12.7258 3.36523 13.6226 4.2621 13.6226 5.36844C13.6226 6.47478 12.7258 7.37164 11.6194 7.37164H9.61621V3.36523Z" fill="#FF7262"/><path d="M13.6226 9.37528C13.6226 10.4816 12.7258 11.3785 11.6194 11.3785C10.5131 11.3785 9.61621 10.4816 9.61621 9.37528C9.61621 8.26894 10.5131 7.37207 11.6194 7.37207C12.7258 7.37207 13.6226 8.26894 13.6226 9.37528Z" fill="#1ABCFE"/></g><defs><clipPath id="clip0_7270_17125"><rect width="19.2308" height="18.75" fill="white"/></clipPath></defs></svg>',
    name: 'Figma',
    value: 'FIG',
    disabled: true
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="50" height="50" viewBox="0 0 60 60" version="1.1"><title>adobe</title><desc>Created with Sketch.</desc><defs></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" sketch:type="MSPage"><g id="adobe" sketch:type="MSArtboardGroup" fill="#fa0c00"><path d="M37.8297763,3 L60,3 L60,56 L37.8297763,3 Z M22.1972229,3 L0,3 L0,56 L22.1972229,3 Z M30.0077141,22.5281464 L44.1437388,56 L34.8791463,56 L30.6479815,45.3373924 L20.3034199,45.3373924 L30.0077141,22.5281464 Z" id="Fill-1" sketch:type="MSShapeGroup"></path></g></g></svg>',
    name: 'Adobe',
    value: 'ADOBE',
    disabled: false
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="#6122e8"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"/></svg>',
    name: 'Ready-to-post files only (JPG, PNG, MP4)',
    value: 'ready',
    disabled: false
  },
  {
    images: '<svg width="50" height="48" viewBox="0 0 240 234" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M197.5 0H42.5C19.0279 0 0 19.0279 0 42.5V191.5C0 214.972 19.0279 234 42.5 234H197.5C220.972 234 240 214.972 240 191.5V42.5C240 19.0279 220.972 0 197.5 0Z" fill="#8A3FFC"/><path d="M55.9709 150H41.1413L63.7372 84.5455H81.571L104.135 150H89.3054L72.9098 99.5028H72.3984L55.9709 150ZM55.044 124.272H90.0724V135.075H55.044V124.272ZM125.373 121.619V150H111.757V100.909H124.733V109.57H125.309C126.395 106.715 128.217 104.457 130.774 102.795C133.331 101.112 136.431 100.27 140.074 100.27C143.483 100.27 146.456 101.016 148.991 102.507C151.527 103.999 153.498 106.129 154.904 108.899C156.31 111.648 157.013 114.929 157.013 118.743V150H143.398V121.172C143.419 118.168 142.652 115.824 141.097 114.141C139.542 112.436 137.4 111.584 134.673 111.584C132.841 111.584 131.221 111.978 129.815 112.766C128.43 113.555 127.343 114.705 126.555 116.218C125.788 117.71 125.394 119.51 125.373 121.619ZM174.392 168.409C172.666 168.409 171.046 168.271 169.534 167.994C168.042 167.738 166.806 167.408 165.826 167.003L168.894 156.839C170.492 157.33 171.931 157.596 173.209 157.638C174.509 157.681 175.627 157.383 176.565 156.744C177.524 156.104 178.301 155.018 178.898 153.484L179.697 151.406L162.087 100.909H176.405L186.568 136.96H187.08L197.339 100.909H211.753L192.673 155.305C191.757 157.947 190.51 160.249 188.933 162.209C187.378 164.19 185.407 165.714 183.021 166.779C180.634 167.866 177.758 168.409 174.392 168.409Z" fill="white"/></g></svg>',
    name: 'Let designer decide',
    value: 'any',
    disabled: false
  }
]
// list squad category
export const list_squad_category: Array<string> = [
  'Client squads', 'Design squads', 'Training squads', 'Others'
]

export const metadata_label = {
  daytime_design: 'Full time zone coverage',
  has_pm: 'Project Manager',
  has_ad: 'Art Director',
  limit_user: "Total limit team member",
  total_active_project: "Total active projects",
  total_category: "Total category",
  limit_project: "project in subscription time",
  canva: 'Canva editing',
  figma: 'Figma editing',
  root_limit_project: 'projects per month'
}

